import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
//Utils 
import Empty from "../../../utils/Empty";
import { RenderIf } from "../../../utils/RenderIf";
//Img
import sad_products from '../../../PaymentPost/img/emptyassing.png';
//Alerts 
import ErrorAlert from "../../../Alerts/ErrorAlert";
import AlertSmall from "../../../Alerts/AlertSmall";
//API 
import { PreOrderFetchAPI } from "../../../../api/Paymentpost/PreOrder";
import { TablesFetchAPI } from "../../../../api/Tables";
import { OrdersFetchAPI } from "../../../../api/Orders";
import { PrinterFetchAPI } from "../../../../api/Printer";
import { MachinesFetchAPI } from "../../../../api/Machines";
import { CategriesPosFetchAPI } from "../../../../api/Paymentpost/CategoriesPos";
import { TableSessionsFetchAPI } from "../../../../api/TableSessions";
import RfmCustomizeInvoiceModal from "./RfmCustomizeInvoiceModal";
import PrepayQrModal from "../PrepayQrModal";
import PospagoQrModal from "../PospagoQrModal";
//Components
import printOrderData from "../../../PaymentPost/PrintOrderData";
//Sockets
import Socket from "../../../utils/Socket.config";
//Css
import '../../css/OrderDetailsModal.css'
import useScrollArrows from "../../js/Usescrollarrows";
import formatOrderCode from "../../js/formatOrderCode";

import RfmConfirm from "./RfmConfirm";

// Convierte los segments crudos de una linea de orden (app/models/temp_orders.js#groups[].segments en
// el backend) al shape que el render de items ya sabe pintar (it.modifiers) - usado tanto por la vista
// liviana de la grilla de mesas como por el detalle de pedido de este archivo, para que un producto con
// modificadores (ej. "#7 Costillas Agridulces" con su guarnicion/bebida) se vea igual en ambos lados.
// Impuesto de una linea: taxes[].total solo viene poblado cuando el POS resolvio un descuento; una
// linea recien agregada por el cliente trae solo la tasa (taxtValue). Mismo calculo que
// calculateTotalProductPrice del backend, para que cuadre con el total de la mesa.
const getLineTaxTotal = (line) => {
  const taxes = Array.isArray(line?.taxes) ? line.taxes : [];
  const stored = taxes.reduce((sum, tax) => sum + (Number(tax.total) || 0), 0);
  if (stored > 0) return stored;
  const qty = Number(line?.qty ?? line?.amount ?? 1) || 1;
  const unitDiscount = Number(line?.discount || 0) / qty;
  const base = qty * (Number(line?.price || 0) - unitDiscount);
  const raw = taxes.reduce((sum, tax) => sum + base * (Number(tax.taxtValue) || 0), 0);
  return Math.ceil(raw * 100 - 1e-9) / 100;
};

const segmentsToModifiers = (segments = []) => (Array.isArray(segments) ? segments.map((s) => ({
  segment_id: s.segment_id,
  name: s.segment_name || s.name || `Segmento ${s.segment_id}`,
  selections: [
    {
      item_id: s?.item?.item_id || null,
      name: s?.item?.name || s?.name || "",
      price: Number(s?.item?.price || 0),
      img: s?.item?.img || null,
      description: s?.item?.description || null,
      segment_id: s.segment_id,
    },
  ],
})) : []);



/**
 * Modal host:
 * <RfmModals
 *   modal={modal}
 *   onClose={() => setModal(null)}
 *   tables={tables}
 *   setTables={setTables}
 * />
 *
 * modal shape:
 * { name: string, payload: any }
 */
export default function RfmModals({ modal, onClose, tables, setTables, onCreateTempOrder, onOpenModal, onSendToPay, token, branchoffice_code, business_code, onRequireUserCodeLogin, onOrdersChanged, onOpenPosCharge }) {
  const name = modal?.name || null;
  const payload = modal?.payload || {};
  const navigate = useNavigate();
  const [infoPrinter, setInfoPrinter] = useState({
    printer_comanda: "",
    printer_ticket: "",
    printer_zebra: "",
    printer_ip: "",
    printer_comanda_ip: "",
  });
  const [printers, setPrinters] = useState([]);
  let arrayPrintersTemp = [];

  const table = useMemo(() => {
    if (!payload?.tableId) return null;
    return tables.find((t) => t.id === payload.tableId) || null;
  }, [tables, payload?.tableId]);

  const patchTable = (tableId, patch) => {
    setTables((prev) => prev.map((t) => (t.id === tableId ? { ...t, ...patch } : t)));
  };

  const refreshTableOrdersAndDiners = async (tableId) => {
    const [ordersResp, dinersResp] = await Promise.all([
      TablesFetchAPI.getTempOrdersByTableId(tableId, token),
      TablesFetchAPI.getTableDinners(tableId, token),
    ]);

    const normalizeBackendOrdersToTableOrders = (backendOrders = []) => {
      return (backendOrders || []).map((ord) => ({
        id: ord._id || ord.id || ord.code,
        transaction_code: ord.transaction_code || String(ord._id || ord.id).slice(-6),
        status: ord.status_id === 1 ? "open" : String(ord.status_id),
        order_source: ord.order_source || ord.source || ord.orderSource || null,
        table_session_uuid: ord.table_session_uuid || ord.session_uuid || null,
        // Fase 2/5: misma version optimista que Reservation.jsx#normalizeBackendOrdersToTableOrders
        // (contrato confirmado en app/models/temp_orders.js del backend).
        shared_order_version: Number(ord.shared_order_version || 1),
        created_at: ord.createdAt || new Date().toISOString(),
        total: Number(ord.total || 0),
        items: (ord.groups || []).map((g, index) => ({
          signature: `backend:${ord._id || ord.code}:${g.segments_string || g.group_id}:${index}`,
          group_id: g.group_id,
          name: g.name,
          qty: Number(g.amount || 1),
          base_price: Number(g.price || 0),
          price: Number(g.price || 0),
          diner_id: g.diner_id || null,
          diner_name: g.diner_name || "",
          modifiers: Array.isArray(g.segments) && g.segments.length > 0 ? segmentsToModifiers(g.segments) : [],
          modifiers_total: 0,
          // Fase 5: ver Reservation.jsx#normalizeBackendOrdersToTableOrders - mismos campos, misma
          // fuente real (app/models/temp_orders.js#groups en el backend).
          line_uuid: g.line_uuid || (g._id ? String(g._id?.$oid || g._id) : null),
          participant_uuid: g.participant_uuid || null,
          participant_display_name: g.participant_display_name || "",
          line_status: g.line_status || "SUBMITTED",
          submitted_at: g.submitted_at || null,
          revision: Number(g.revision || 1),
        })),
      }));
    };

    const normalizeBackendDiners = (backendDiners = []) => {
      return (backendDiners || []).map((d) => {
        const normalizedOrders = (d.items || []).map((item, index) => ({
          id: `${item.source || "item"}_${index}_${item.group_id || item.combo_id || ""}`,
          source: item.source || "group",
          name: item.name || "Producto",
          qty: Number(item.qty || 1),
          price: Number(item.price || 0),
          emoji: item.source === "combo" ? "🥡" : "🍽️",
          total: Number(item.total || 0),
          order_id: item.order_id,
          group_id: item.group_id || null,
          combo_id: item.combo_id || null,
        }));

        return {
          diner_id: d.diner_id,
          name: d.name || "Comensal",
          seat_number: d.seat_number ?? null,
          selected_order_id: d.order_id || d.orders?.[0] || normalizedOrders.find((x) => x.order_id)?.order_id || null,

          orders: normalizedOrders,
        };
      });
    };

    const tableOrders = normalizeBackendOrdersToTableOrders(ordersResp?.data?.orders || []);
    const normalizedDiners = normalizeBackendDiners(dinersResp?.data?.diners || []);
    const totalToPay = tableOrders.reduce((sum, o) => sum + Number(o.total || 0), 0);

    patchTable(tableId, {
      total: Number(totalToPay),
      table_orders: tableOrders,
      backend_orders: tableOrders,
      comensales: normalizedDiners,
      guests: normalizedDiners.length,
    });
  };


  //For printing work flow
  const getCategoriesByprinter = async (printer) => {
    try {
      const response = await CategriesPosFetchAPI.getCategoriesByPrinters(
        printer.printer_id,
        localStorage.getItem("x-access-machine-token")
      );
      printer.categories = response.data.categories;
    } catch (err) {
      printer.categories = [];
    }

    arrayPrintersTemp.push(printer);
  };

  const getPrinter = async () => {
    try {
      const machine = JSON.parse(localStorage.getItem("machine"));
      const response = await PrinterFetchAPI.getPrinter(
        localStorage.getItem("x-access-machine-token"),
        machine.id
      );

      let arrayPrinters = response.data.printers || [];
      let printer_Comanda = "";
      let printer_ticket = "";
      let printer_zebra = "";
      let printer_ip = "";
      let printer_comanda_ip = "";

      arrayPrintersTemp = [];

      for (let i = 0; i < arrayPrinters.length; i++) {
        await getCategoriesByprinter(arrayPrinters[i]);

        if (arrayPrinters[i].printer_type === "Tickets") {
          printer_ticket = arrayPrinters[i].printer_name;
          printer_ip = arrayPrinters[i].ip || "";
        } else if (arrayPrinters[i].printer_type === "Comanda") {
          printer_Comanda = arrayPrinters[i].printer_name;
          printer_comanda_ip = arrayPrinters[i].ip || "";
        } else if (arrayPrinters[i].printer_type === "Zebra") {
          printer_zebra = arrayPrinters[i].printer_name;
        }
      }

      setPrinters(arrayPrintersTemp);
      setInfoPrinter({
        printer_comanda: printer_Comanda,
        printer_ticket,
        printer_zebra,
        printer_ip,
        printer_comanda_ip,
      });
    } catch (err) {
      console.error(err);
    }
  };

  // onlyComanda: solo la(s) impresora(s) de cocina, sin ticket de precuenta - mismo criterio que
  // ModalCreatePreOrder.printOrder(onlyComanda). El servicio de impresion pide al backend las lineas
  // en send_to_kitchen aun sin imprimir (getFilterTempOrderByIdToImpress) y las marca como impresas.
  const printPreOrderFromTables = async ({ orderId, transactionCode, tableName, amountItems, onlyComanda = false }) => {
    try {
      const machine = JSON.parse(localStorage.getItem("machine"));
      let ip_print = "localhost";

      if (
        localStorage.getItem("ip_printer") &&
        localStorage.getItem("ip_printer") !== ""
      ) {
        ip_print = localStorage.getItem("ip_printer");
      }

      let dataPrinters = onlyComanda
        ? printers.filter((printer) => printer.printer_type === "Comanda")
        : printers;

      // Sin esto, si esta maquina no tiene ninguna impresora "Comanda" asignada, el job se mandaba
      // igual con Printers: [] - el servicio de impresion no tenia a donde imprimir, no imprimia nada,
      // pero como no lanzaba error el catch de abajo nunca se activaba y el mesero veia "Comanda
      // enviada a imprimir" (exito falso) en vez de un aviso real de que falta configurar la impresora.
      if (onlyComanda && dataPrinters.length === 0) {
        throw new Error("Esta maquina no tiene impresora de comanda asignada");
      }

      const JsonImprimir = [
        {
          type_ticket: "precuenta",
          table_name: tableName,
          Printers: dataPrinters,
          Nombre_maquina_impresora: infoPrinter.printer_ticket,
          Nombre_cocina_impresora: infoPrinter.printer_comanda,
          Nombre_zebra_impresora: infoPrinter.printer_zebra,
          // Solo comanda -> IP de la impresora de cocina; con la de tickets el trabajo apuntaba a otro
          // equipo y no salia nada (los datos llegaban bien al servicio de impresion).
          PRINTER_IP: onlyComanda ? infoPrinter.printer_comanda_ip : infoPrinter.printer_ip,
          Id_Orden_Imprimir: orderId,
          token: localStorage.getItem("x-access-machine-token"),
          transaction_code: transactionCode,
          // Total de lineas (groups) de la orden: es lo que el servicio de impresion compara con el
          // `amount_item` que devuelve el backend (si no coinciden descarta la comanda en silencio).
          amount_item: amountItems,
          imprimir_comanda: "si",
        },
      ];

      // En Android, printOrderData ya entrega el trabajo por el puente nativo (se no-opea sola si
      // window.AndroidBridge no existe - ver PrintOrderData.jsx). El canal HTTP de abajo se intenta
      // igual (mismo patron que utils/PrintPaidOrder.js#reprintPaidOrder), pero si Android ya imprimio,
      // un fallo de ese canal (normal: una tablet Android no corre el servicio local de Windows) NO
      // debe mostrarse como fallo real - solo si Android tampoco estaba disponible.
      const hasAndroidBridge = typeof window !== "undefined" && typeof window.AndroidBridge?.printOrder === "function";
      if (hasAndroidBridge) printOrderData(JsonImprimir);

      try {
        const response_machine = await MachinesFetchAPI.getmachineByid(
          machine.id,
          localStorage.getItem("x-access-machine-token")
        );

        if (ip_print === "localhost") {
          await PrinterFetchAPI.printOrder(
            ip_print,
            JsonImprimir,
            response_machine.data.data.windows_ip
          );
        } else {
          await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir);
        }
      } catch (err) {
        if (!hasAndroidBridge) throw err;
      }

      if (onlyComanda) {
        // Diagnostico: a que impresora se mando de verdad (nombre + IP). El backend entrega los datos bien
        // (200) aun cuando no sale papel, asi que lo unico que se puede verificar desde aqui es el destino.
        const sentTo = `${infoPrinter.printer_comanda || "sin impresora de comanda"}${infoPrinter.printer_comanda_ip ? ` (${infoPrinter.printer_comanda_ip})` : " (sin IP)"}`;
        console.log("[Comanda] Trabajo enviado:", JsonImprimir[0]);
        AlertSmall(`Comanda enviada a imprimir -> ${sentTo}`, "success");
      } else {
        AlertSmall("Precuenta enviada a imprimir", "success");
      }
    } catch (err) {
      console.error(err);
      if (onlyComanda) {
        // No se avisa aqui: sendSingleItemToKitchen/sendAllPendingItemsToKitchen son quienes llaman
        // con onlyComanda=true, y necesitan enterarse del fallo real (para revertir kitchen_action en
        // vez de dejarlo marcado como "enviado" sin haberse impreso) antes de avisarle al mesero con
        // el mensaje correcto. Re-lanzar es lo que permite eso.
        throw err;
      }
      AlertSmall("La precuenta se creó/actualizó, pero falló la impresión", "warning");
    }
  };

  useEffect(() => {
    getPrinter();
  }, []);

  if (!name) return null;

  // Helpers: recompute total + orders flat + guests from comensales
  const computeFromComensales = (comensales = []) => {
    const total = comensales.reduce(
      (sum, c) => sum + (c.orders || []).reduce((s, o) => s + (Number(o.price || 0) * Number(o.qty || 1)), 0),
      0
    );
    const orders = comensales.flatMap((c) => c.orders || []);
    const guests = comensales.length;
    return { total, orders, guests };
  };

  //Update order items 
  const mergeItemsBySignature = (baseItems = [], addItems = []) => {
    const map = new Map();

    const put = (it) => {
      const key = it.signature || `simple:${it.group_id}`;
      const prev = map.get(key);

      if (!prev) {
        map.set(key, { ...it, qty: Math.max(1, Number(it.qty || 1)) });
        return;
      }

      map.set(key, {
        ...prev,
        ...it,
        qty: Math.max(1, Number(prev.qty || 1) + Math.max(1, Number(it.qty || 1))),
      });
    };

    [...baseItems, ...addItems].forEach(put);
    return Array.from(map.values());
  };

  const computeOrderTotal = (items = []) => {
    return items.reduce((s, it) => s + Number(it.price || 0) * Number(it.qty || 1), 0);
  }

  const markOrderStatus = (tableId, orderId, status) => {
    setTables((prev) =>
      prev.map((t) => {
        if (t.id !== tableId) return t;
        const orders = Array.isArray(t.table_orders) ? [...t.table_orders] : [];
        const idx = orders.findIndex((o) => String(o.id) === String(orderId));
        if (idx < 0) return t;
        orders[idx] = { ...orders[idx], status };
        return { ...t, table_orders: orders };
      })
    );
  };

  //Formating data for backend (segments/modifiers)
  const getProductByGroupId = (groupId) => {
    const raw = localStorage.getItem("generalData");
    const generalData = raw ? JSON.parse(raw) : [];
    const products = generalData?.[0]?.data?.groups || [];
    return products.find((p) => String(p.group_id || p.id) === String(groupId)) || null;
  };

  const buildSegmentsForBackend = (selectedLine) => {
    const modifiers = Array.isArray(selectedLine.modifiers) ? selectedLine.modifiers : [];
    const out = [];

    modifiers.forEach((seg) => {
      const selections = Array.isArray(seg.selections) ? seg.selections : [];
      selections.forEach((opt) => {
        // Backend-style segment row
        out.push({
          name: opt.name,
          img: opt.img || null,
          description: opt.description || null,
          item_id: opt.item_id,
          segment_id: opt.segment_id || seg.segment_id,
          price: Number(opt.price || 0),
          branchoffice_id: opt.branchoffice_id ?? null,
          external_reference: opt.external_reference ?? null,
          turnDefault: Boolean(opt.turnDefault ?? false),
          amount: 1,
          segment_name: seg.name,        // important for UI/back
          cantidadItem: 1,
          item: {
            name: opt.name,
            img: opt.img || null,
            description: opt.description || null,
            item_id: opt.item_id,
            segment_id: opt.segment_id || seg.segment_id,
            price: Number(opt.price || 0),
            branchoffice_id: opt.branchoffice_id ?? null,
            external_reference: opt.external_reference ?? null,
            turnDefault: Boolean(opt.turnDefault ?? false),
            amount: 1,
          },
        });
      });
    });

    return out;
  };

  const buildSegmentsString = (selectedLine) => {
    const qty = Number(selectedLine.qty || 1);
    const gid = selectedLine.group_id;

    const parts = [];
    const modifiers = Array.isArray(selectedLine.modifiers) ? selectedLine.modifiers : [];
    modifiers.forEach((seg) => {
      const selections = Array.isArray(seg.selections) ? seg.selections : [];
      selections.forEach((opt) => {
        parts.push(`${seg.segment_id}${opt.item_id}`);
      });
    });

    return `${qty}${gid}${parts.join("")}`;
  };

  const buildOrdenLines = (selectedItems, tipoOrden = "comer aqui") => {
    return selectedItems
      .map((line) => {
        const product = getProductByGroupId(line.group_id);
        if (!product) return null;

        const qty = Math.max(1, Number(line.qty || 1));
        const base_price = Number(product.price || 0);

        // Your frontend line.price already includes modifiers
        const unitPrice = Number(line.price ?? base_price);

        const segmentsBackend = buildSegmentsForBackend(line);
        const segmentsString = buildSegmentsString(line);

        // IMPORTANT: backend uses both `segments` and `DetalleSegmentos`
        return {
          ...product,

          amount: qty,
          cantidadItem: qty,
          isNewAdd: true,
          delivery_type: tipoOrden,
          note: "",
          unit_discount: 0,
          product_discount: 0,
          base_price,
          valueOriginal: unitPrice,
          descuento: 0,
          discount: 0,
          kitchen_action: line.send_to_kitchen === "send_to_kitchen" ? "send_to_kitchen" : "hold",
          note: String(line.note || "").trim(),
          // Segments formatted
          segments: segmentsBackend,
          DetalleSegmentos: segmentsBackend,
          segments_string: segmentsString,

          // Override price if you want POS-style unit price with modifiers
          price: unitPrice,
        };
      })
      .filter(Boolean);
  };

  const buildGroupsForUpdatePayload = (selectedItems, tipoOrden = "comer aqui") => {
    // Reusa tu builder que ya convierte a producto completo
    // Si ya tienes buildOrdenLines(), úsalo. Si no, adapta a tu helper actual.
    const ordenLines = buildOrdenLines(selectedItems, tipoOrden);

    // Para update, el backend espera "groups" (no "Orden")
    // y suele esperar segments/DetalleSegmentos ya formateados
    return ordenLines.map((p) => ({
      ...p,

      // Asegura campos típicos de update
      amount: Number(p.amount || p.cantidadItem || 1),
      cantidadItem: Number(p.cantidadItem || p.amount || 1),

      // algunos backends esperan amount_to_impress / amount_Original
      amount_to_impress: Number(p.amount_to_impress || p.amount || 1),
      amount_Original: Number(p.amount_Original || p.amount || 1),

      descuento: Number(p.descuento || 0),
      unit_discount: Number(p.unit_discount || 0),
      discount: Number(p.discount || 0),
      note: String(p.note || "").trim(),
      delivery_type: p.delivery_type || tipoOrden,
      kitchen_action: p.kitchen_action === "send_to_kitchen" ? "send_to_kitchen" : "hold",

      // si tu builder ya pone segments y DetalleSegmentos, perfecto
      segments: Array.isArray(p.segments) ? p.segments : [],
      DetalleSegmentos: Array.isArray(p.DetalleSegmentos) ? p.DetalleSegmentos : [],
    }));
  };

  // function to build the totals and taxes in the format that backend expects, from an array of order lines (groups) with segments inside; this is needed to send correct totals on order update when adding products to existing order with groups/segments, since backend expects full groups on update and we need to recalculate totals with the new groups+segments
  const buildTotalsAndTaxes = (ordenLines = []) => {
    let subtotal = 0;
    const taxMap = new Map();

    ordenLines.forEach((p) => {
      const qty = Number(p.amount || 1);
      const lineBase = Number(p.price || 0) * qty;
      subtotal += lineBase;

      const taxes = Array.isArray(p.taxes) ? p.taxes : [];
      taxes.forEach((t) => {
        const rate = Number(t.taxtValue || 0);
        const taxTotal = lineBase * rate;

        const key = String(t.tax_id);
        const prev = taxMap.get(key);

        const row = {
          dTasaITBMSValue: t.dTasaITBMSValue,
          percentage: t.percentage,
          tax: t.tax,
          tax_id: t.tax_id,
          taxtValue: rate,
          total: (prev?.total || 0) + taxTotal,
        };

        taxMap.set(key, row);
      });
    });

    const taxesArr = Array.from(taxMap.values()).map((x) => ({
      ...x,
      total: Number(x.total.toFixed(2)),
    }));

    const itbms = Number(taxesArr.reduce((s, x) => s + Number(x.total || 0), 0).toFixed(2));
    const Total = Number((subtotal + itbms).toFixed(2));

    return {
      subtotal: Number(subtotal.toFixed(2)),
      itbms,
      Total,
      taxes: taxesArr,
    };
  };

  const buildPreOrderPayload = ({ selectedItems, table, machine_id, branchoffice_id, user }) => {
    const tipoOrden = "comer aqui";
    const Orden = buildOrdenLines(selectedItems, tipoOrden);
    const totals = buildTotalsAndTaxes(Orden);

    let data = {
      client_name: "Cliente generico",
      table_name: table?.number || 0,
      table_id: table?.id || 0,
      table_code: table?.code || "",
      client_phone: "",
      ruc: 0,
      dv: 0,
      id_Client: 0,
      client_id: 0,
      dgi_qr: "0",

      Orden,
      combos: [],
      Descuento: 0,

      Total: totals.Total,
      itbms: totals.itbms,
      subtotal: totals.subtotal,
      taxes: totals.taxes,

      machine_id,
      branchoffice_id,
      tipoOrden,
      paymethod: 0,
      localizador: 0,
      discounts: [],
      is_discount_notification: false,
      is_cupon: false,
      is_authorized: true,
      is_devolution_notification: false,
      is_pre_order: true,

      user: user || { id: 0, name: "Unknown", code: "" },
      email_cc: [""],
    };


    //We check if the user logged is a waiter to send the waiter info to the pre-order
    if (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).role.find(r => r.name === "Mesero") != undefined) {
      data.waiter = {
        id: JSON.parse(localStorage.getItem("user")).id,
        name: JSON.parse(localStorage.getItem("user")).name,
        code: JSON.parse(localStorage.getItem("user")).user_code
      }
    }
    return data;
  };


  return (
    <>
      {name === "add-order" && table && (
        <AddOrderModal
          table={table}
          onClose={onClose}
          onSave={(order) => {
            // Si no hay comensales, crea uno default
            let comensales = [...(table.comensales || [])];
            if (comensales.length === 0) comensales = [{ name: "General", orders: [] }];

            // agrega al primer comensal (General)
            const first = comensales[0];
            const orders = [...(first.orders || [])];
            orders.push(order);
            comensales[0] = { ...first, orders };

            const derived = computeFromComensales(comensales);
            patchTable(table.id, {
              comensales,
              guests: derived.guests,
              total: derived.total,
              orders: derived.orders,
              status: table.status === "available" ? "occupied" : table.status,
            });
            onClose();
          }}
        />
      )}

      {name === "remove-comensal" && table && (
        <ConfirmModal
          title="Eliminar comensal"
          description={`¿Seguro que deseas eliminar a ${payload?.dinerName || "este comensal"}? Sus productos quedarán sin asignar.`}
          confirmText="Eliminar"
          onClose={onClose}
          onConfirm={async () => {
            try {
              const tableId = payload?.tableId;
              const orderId = payload?.orderId;
              const dinerId = payload?.dinerId;

              if (!tableId || !orderId || !dinerId) {
                return ErrorAlert("Error", "Faltan datos para eliminar el comensal");
              }

              const resp = await TablesFetchAPI.deleteTableDinner(
                tableId,
                dinerId,
                token
              );

              if (!resp?.data?.success) {
                throw new Error(resp?.data?.message || "No se pudo eliminar el comensal");
              }

              await refreshTableOrdersAndDiners(tableId);
              onClose();
            } catch (err) {
              console.error(err);
              ErrorAlert("Error al eliminar comensal", err?.message || "Ocurrió un error");
            }
          }}
        />
      )}

      {name === "remove-order-comensal" && table && (
        <ConfirmModal
          title="Quitar pedido del comensal"
          description={`¿Seguro que deseas quitar "${payload?.itemName || "este producto"}" de ${payload?.dinerName || "este comensal"}?`}
          confirmText="Quitar"
          onClose={onClose}
          onConfirm={async () => {
            try {
              const tableId = payload?.tableId;
              const orderId = payload?.orderId;
              const dinerId = payload?.dinerId;
              const source = payload?.source;
              const groupId = payload?.groupId;
              const comboId = payload?.comboId;

              if (!tableId || !orderId || !dinerId || !source) {
                return ErrorAlert("Error", "Faltan datos para quitar el producto");
              }

              const resp = await TablesFetchAPI.removeItemsFromDiner(
                tableId,
                {
                  order_id: orderId,
                  diner_id: dinerId,
                  source,
                  group_id: groupId,
                  combo_id: comboId,
                },
                token
              );

              if (!resp?.data?.success) {
                throw new Error(resp?.data?.message || "No se pudo quitar el producto del comensal");
              }

              await refreshTableOrdersAndDiners(tableId);
              onClose();
            } catch (err) {
              console.error(err);
              ErrorAlert("Error al quitar producto", err?.message || "Ocurrió un error");
            }
          }}
        />
      )}

      {name === "split-bill" && table && (
        <SplitBillModal
          table={table}
          onClose={onClose}
          onApply={(paidAmount) => {
            const currentPaid = Number(table.paid || 0);
            const total = Number(table.total || 0);

            const newPaid = Math.max(0, Math.min(total, currentPaid + paidAmount));

            // si paga todo, resetea mesa (igual que tu offcanvas)
            if (total > 0 && newPaid >= total) {
              patchTable(table.id, {
                paid: total,
                status: "available",
                guests: 0,
                total: 0,
                time: null,
                orders: [],
                comensales: [],
                reservation: null,
              });
              onClose();
              return;
            }

            patchTable(table.id, { paid: newPaid });
            onClose();
          }}
        />
      )}

      {name === "delete-table" && table && (
        <ConfirmModal
          title="Eliminar mesa"
          description={`Se eliminará la mesa ${table.number}.`}
          confirmText="Eliminar mesa"
          onClose={onClose}
          onConfirm={() => {
            setTables((prev) => prev.filter((t) => t.id !== table.id));
            onClose();
          }}
        />
      )}


      {name === "add-products" && table && (
        <AddProducts
          title={payload?.orderId ? "Agregar mas productos" : `Crear orden para la mesa ${table.number}`}
          description={payload?.orderId ? "Seleccione los productos que desea agregar a la orden" : `Se agregaran productos a la mesa ${table.number}`}
          confirmText="Confirmar"
          onClose={onClose}
          onConfirm={async (selectedItems) => {
            let newOrderDetailsResponse = null;
            if (!Array.isArray(selectedItems) || selectedItems.length === 0) return onClose();

            //If the orderid is present, we are adding products to an existing order 
            if (payload?.orderId) {
              // 1) We need to merge selectedItems with existing items in the order (if any) to avoid losing data on backend update, since backend expects full order lines on update (no append) and we want to preserve unedited items/groups. So we do it in 3 steps:
              const currentTable = tables.find((t) => t.id === table.id);
              const currentOrderUI = (currentTable?.table_orders || []).find(
                (o) => String(o.id) === String(payload.orderId)
              );

              const baseItems = currentOrderUI?.items || [];
              const nextItems = mergeItemsBySignature(baseItems, selectedItems);

              // 2) We update UI with nextItems 
              setTables((prev) =>
                prev.map((t) => {
                  if (t.id !== table.id) return t;
                  const orders = Array.isArray(t.table_orders) ? [...t.table_orders] : [];
                  const idx = orders.findIndex((o) => String(o.id) === String(payload.orderId));
                  if (idx < 0) return t;

                  orders[idx] = {
                    ...orders[idx],
                    items: nextItems,
                    total: computeOrderTotal(nextItems),
                  };
                  return { ...t, table_orders: orders };
                })
              );

              // 3) we get the order of backend (with groups)
              const resp = await OrdersFetchAPI.getTempOrderById(
                payload.orderId,
                localStorage.getItem("x-access-machine-token")
              );
              const backendOrder = resp?.data?.pre_order; // contains real groups

              // 4) build ONLY the NEW groups from selectedItems
              const tipoOrden = backendOrder?.order_type || "comer aqui";
              // Pre-pago: lo que se agrega queda sin pagar y el cobro es lo que lo manda a cocina; el
              // interruptor "Enviar a cocina" del selector no aplica (ver canSendLineToKitchen en OrderDetailsModal).
              const addingToPrepayOrder = String(backendOrder?.order_source || "").toUpperCase() === "ECOMMERCE_TABLE_PREPAY";
              const newGroups = buildGroupsForUpdatePayload(selectedItems, tipoOrden).map((g) => (
                addingToPrepayOrder ? { ...g, kitchen_action: "hold" } : g
              ));

              // 5) existing groups from backend (preserving _id)
              const existingGroups = Array.isArray(backendOrder?.groups) ? backendOrder.groups : [];

              // 6) final concat (do not delete previous)
              const groupsFinal = [...existingGroups, ...newGroups];

              // 7) recalculate totals/taxes with groupsFinal
              const totals = buildTotalsAndTaxes(groupsFinal);

              // 8) build payload update with correct _id
              const payloadUpdate = {
                _id: backendOrder?._id?.$oid ?? backendOrder?._id ?? payload.orderId,
                order_type: backendOrder?.order_type,
                client_name: backendOrder?.client_name,
                localizador: backendOrder?.locator ?? backendOrder?.localizador,
                table_name: backendOrder?.table_name,
                ruc: backendOrder?.client_ruc ?? backendOrder?.ruc,
                dv: backendOrder?.client_dv ?? backendOrder?.dv,
                is_discount_notification: Boolean(backendOrder?.is_discount_notification),

                groups: groupsFinal,
                combos: backendOrder?.combos || [],
                discounts: backendOrder?.discounts || [],

                taxes: totals.taxes || [],
                discount: backendOrder?.discount ?? 0,
                is_authorized: true,

                total: totals.Total,
                tax: totals.itbms,
                subtotal: totals.subtotal,

                note: String(backendOrder?.note || "").trim(),
                removed_products: [],
                email_cc: backendOrder?.email_cc || [""],
              };

              await PreOrderFetchAPI.updateOrderTempPreOrder(payloadUpdate, token);

              onRequireUserCodeLogin?.();

              try {
                await printPreOrderFromTables({
                  orderId: payloadUpdate._id,
                  transactionCode:
                    backendOrder?.transaction_code ||
                    currentOrderUI?.transaction_code ||
                    "",
                  tableName: backendOrder?.table_name || table?.number || 0,
                  amountItems: groupsFinal.length,
                });
              } catch (__) { }


              onOpenModal?.("order-details", { tableId: table.id, orderId: payload.orderId });
              return;
            }
            //Otherwise, we are creating a new order for the table with the selected products
            if (!payload?.orderId) {
              // 2) Build backend payload
              const machine_id = payload?.machine_id || JSON.parse(localStorage.getItem("machine")).id;         // <-- replace with your real value/source
              const branchoffice_id = payload?.branchoffice_id || JSON.parse(localStorage.getItem("branchoffice")).id; // <-- replace with your real value/source
              const user = payload?.user || { id: JSON.parse(localStorage.getItem("user")).id, name: JSON.parse(localStorage.getItem("user")).name, code: JSON.parse(localStorage.getItem("user")).user_code }; // <-- replace

              const body = buildPreOrderPayload({
                selectedItems,
                table,
                machine_id,
                branchoffice_id,
                user,
              });


              console.log(body, "payload for backend order creation");

              // 3) Send to backend
              newOrderDetailsResponse = await PreOrderFetchAPI.createPreOrder(body, token);

              onRequireUserCodeLogin?.();

              // 4) Print pre-order (optimistic, do not wait)
              try {
                const createdOrder = newOrderDetailsResponse?.data?.newTempOrder;

                if (createdOrder?._id && createdOrder?.code) {
                  await printPreOrderFromTables({
                    orderId: createdOrder._id,
                    transactionCode: createdOrder.code,
                    tableName: table?.number || body?.table_name || 0,
                    amountItems: selectedItems.length,
                  });
                }
              } catch (__) { }
            }



            // Local fallback: create an order in table_orders
            const newOrder = {
              id: newOrderDetailsResponse?.data?.newTempOrder?._id || `temp-${Date.now()}`,
              transaction_code: newOrderDetailsResponse?.data?.newTempOrder?.transaction_code || `temp-${Date.now()}`,
              table_id: table.id,
              status: "open",
              created_at: new Date().toISOString(),
              items: selectedItems,
              total: computeOrderTotal(selectedItems),
            };

            setTables((prev) =>
              prev.map((t) =>
                t.id !== table.id
                  ? t
                  : { ...t, total: t.total + computeOrderTotal(selectedItems), table_orders: [newOrder, ...(Array.isArray(t.table_orders) ? t.table_orders : [])] }
              )
            );
          }
          }
        />
      )}

      {name === "order-details" && table && (
        <OrderDetailsModal
          table={table}
          orderId={payload.orderId}
          onClose={onClose}
          onOrdersChanged={onOrdersChanged}
          onPrintComanda={(args) => printPreOrderFromTables({ ...args, onlyComanda: true })}
          onOpenPosCharge={onOpenPosCharge}
          onAddProducts={() => onClose() || onCreateTempOrder} // not used directly
          onAddMore={() => onOpenModal?.("add-products", { tableId: table.id, orderId: payload?.orderId })}
          onOpenAddProducts={() => {
            onClose();
            // Re-open product picker to add a NEW order (or later you can support append-to-order)
            // If you want append-to-order, pass orderId in payload and handle it on backend
            setTimeout(() => {
              // Ensure close finishes first
              onClose?.();
            }, 0);
          }}
          onSendToPay={() => {
            // You will wire POS logic later; for now we just mark as ready_to_pay and emit callback if present
            markOrderStatus(table.id, payload?.orderId, "ready_to_pay");
            onSendToPay?.({ tableId: table.id, orderId: payload?.orderId });
            navigate(`/payments/${branchoffice_code}/${business_code}?pre_order=true&table_id=${table.id}&order_id=${payload?.orderId}`);
            onClose?.();
          }}
        />
      )}

      <PrepayQrModal
        show={name === "prepay-qr"}
        onClose={onClose}
        tableId={payload?.tableId}
        tableName={payload?.tableName}
      />

      <PospagoQrModal
        show={name === "pospago-qr"}
        onClose={onClose}
        tableId={payload?.tableId}
        tableName={payload?.tableName}
      />
    </>
  );
}















/* ===========================
   MODAL SHELL (base)
=========================== */
function ModalShell({ title, children, onClose, footer, search }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="ord-modal-backdrop show" onMouseDown={onClose}>
      <div className="ord-modal ord-scope" onMouseDown={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="ord-modal-header">
          <div className="ord-modal-title">{title}</div>
          <button className="ord-btn ord-btn-secondary ord-btn-icon" type="button" onClick={onClose} title="Cerrar">
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <div className="ord-modal-body">{children}</div>

        <div className="ord-modal-footer">{footer}
        </div>
      </div>
    </div>
  );
}

/* ===========================
   ADD COMENSAL
=========================== */
function AddComensalModal({ table, onClose, onSave }) {
  const [name, setName] = useState("");

  return (
    <ModalShell
      title={`Agregar comensal • Mesa ${table.number}`}
      onClose={onClose}
      footer={
        <>
          <div className="ord-footer">

            {/* CANCELAR */}
            <button
              className="ord-btn ord-btn-secondary"
              type="button"
              onClick={onClose}
            >
              Cancelar
            </button>

            <button
              className="ord-btn ord-btn-primary"
              type="button"
              onClick={() => {
                const v = name.trim();
                if (!v) return;
                onSave?.(v);
              }}
            >
              <i className="bi bi-check-lg" /> Guardar
            </button>

          </div>
        </>
      }
    >
      <div className="rfm-form-group">
        <label className="rfm-form-label">Nombre</label>
        <input className="rfm-form-input" placeholder="Ej: Juan" value={name} onChange={(e) => setName(e.target.value)} />
      </div>
    </ModalShell>
  );
}

/* ===========================
   ADD ORDER (GENERAL)
=========================== */
function AddOrderModal({ table, onClose, onSave }) {
  const [emoji, setEmoji] = useState("🍽️");
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [qty, setQty] = useState(1);

  return (
    <ModalShell
      title={`Agregar pedido • Mesa ${table.number}`}
      onClose={onClose}
      footer={
        <>
          <div className="ord-footer">
            <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
              Cancelar
            </button>
            <button
              className="ord-btn ord-btn-primary"
              type="button"
              onClick={() => {
                const n = name.trim();
                const p = Number(price);
                const q = Math.max(1, Number(qty || 1));
                if (!n || !Number.isFinite(p) || p < 0) return;
                onSave?.({ emoji, name: n, price: p, qty: q });
              }}
            >
              <i className="bi bi-check-lg" /> Agregar
            </button>

          </div>

        </>
      }
    >
      <div className="rfm-form-row">
        <div className="rfm-form-group">
          <label className="rfm-form-label">Emoji</label>
          <input className="rfm-form-input" value={emoji} onChange={(e) => setEmoji(e.target.value)} />
        </div>
        <div className="rfm-form-group">
          <label className="rfm-form-label">Cantidad</label>
          <input type="number" min="1" className="rfm-form-input" value={qty} onChange={(e) => setQty(e.target.value)} />
        </div>
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Nombre del platillo</label>
        <input className="rfm-form-input" placeholder="Ej: Hamburguesa" value={name} onChange={(e) => setName(e.target.value)} />
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Precio</label>
        <input type="number" min="0" className="rfm-form-input" value={price} onChange={(e) => setPrice(e.target.value)} />
      </div>
    </ModalShell>
  );
}

/* ===========================
   SPLIT BILL (simple)
=========================== */
function SplitBillModal({ table, onClose, onApply }) {
  const total = Number(table.total || 0);
  const paid = Number(table.paid || 0);
  const remaining = Math.max(0, total - paid);

  const [amount, setAmount] = useState("");

  return (
    <ModalShell
      title={`Dividir / Abonar • Mesa ${table.number}`}
      onClose={onClose}
      footer={
        <>
          <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="ord-btn ord-btn-primary"
            type="button"
            onClick={() => {
              const a = Number(amount) || 0;
              if (a <= 0) return;
              onApply?.(a);
            }}
            disabled={total <= 0}
          >
            <i className="bi bi-check-lg" /> Aplicar
          </button>
        </>
      }
    >
      <div className="rfm-kv" style={{ marginBottom: 12 }}>
        <div className="rfm-kv-row">
          <div className="rfm-kv-label">Total</div>
          <div className="rfm-kv-value">${total.toFixed(2)}</div>
        </div>
        <div className="rfm-kv-row">
          <div className="rfm-kv-label">Pagado</div>
          <div className="rfm-kv-value">${paid.toFixed(2)}</div>
        </div>
        <div className="rfm-kv-row">
          <div className="rfm-kv-label">Pendiente</div>
          <div className="rfm-kv-value">${remaining.toFixed(2)}</div>
        </div>
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Monto a abonar</label>
        <input
          type="number"
          min="0"
          className="rfm-form-input"
          placeholder="Ej: 10"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </div>
    </ModalShell>
  );
}

/* ===========================
   CONFIRM (generic)
=========================== */
function ConfirmModal({ title, description, confirmText = "Confirmar", onClose, onConfirm }) {
  return (
    <ModalShell
      title={title}
      onClose={onClose}
      footer={
        <>
          <div className="ord-footer">
            <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
              Cerrar
            </button>
            <button className="ord-btn ord-btn-secondary" type="button" onClick={onConfirm}>
              <i className="bi bi-exclamation-triangle" /> {confirmText}
            </button>
          </div>
        </>
      }
    >
      <div style={{ color: "var(--text-secondary)", fontSize: ".9rem" }}>{description}</div>
    </ModalShell>
  );
}


/* ===========================
   ADD PRODUCTS (generic)
=========================== */
function AddProducts({ title = "Añadir productos", description, onClose, onConfirm, confirmText = "Confirmar" }) {
  const raw = localStorage.getItem("generalData");
  const generalData = raw ? JSON.parse(raw) : [];
  const products = generalData?.[0]?.data?.groups || [];

  // selectedMap: { [id]: { group_id, name, price, qty } }
  const [step, setStep] = useState("select"); // "select" or "review"
  const [noteKey, setNoteKey] = useState(null); // which item are we adding a note to (by key in selectedMap)
  const [noteValue, setNoteValue] = useState(""); // current note value being edited
  const [selectedMap, setSelectedMap] = useState({});
  // Estado para el campo de búsqueda
  const [search, setSearch] = useState("");

  const [configProduct, setConfigProduct] = useState(null); // config products segments (segmentos)
  const selectedItems = useMemo(() => Object.values(selectedMap), [selectedMap]);

  // Helpers for segmented products (with segmentos)
  const clearProductSelections = (groupId) => {
    setSelectedMap((prev) => {
      const next = { ...prev };
      Object.keys(next).forEach((k) => {
        if (String(next[k]?.group_id) === String(groupId)) delete next[k];
      });
      return next;
    });
  };

  // For segmented products, we allow multiple entries in selectedMap with the same group_id but different keys; this function gets the last one for a given group_id
  const getLastKeyForProduct = (groupId) => {
    const keys = Object.keys(selectedMap).filter((k) => String(selectedMap[k]?.group_id) === String(groupId));
    return keys.length ? keys[keys.length - 1] : null;
  };
  // When inc/dec is triggered for a product with segments, we only modify the last entry for that group_id; if none exists, we create one (inc) or do nothing (dec)
  const incQtyForProduct = (groupId, hasSegments) => {
    if (!hasSegments) return incQty(groupId);

    const lastKey = getLastKeyForProduct(groupId);
    if (!lastKey) {
      const prod = products.find((x) => String(x.group_id || x.id) === String(groupId));
      if (prod) setConfigProduct(prod);
      return;
    }

    setSelectedMap((prev) => ({
      ...prev,
      [lastKey]: { ...prev[lastKey], qty: (prev[lastKey]?.qty || 1) + 1 },
    }));
  };

  const decQtyForProduct = (groupId, hasSegments) => {
    if (!hasSegments) return decQty(groupId);

    const lastKey = getLastKeyForProduct(groupId);
    if (!lastKey) return;

    setSelectedMap((prev) => {
      const current = prev[lastKey];
      if (!current) return prev;

      const nextQty = (current.qty || 1) - 1;
      if (nextQty <= 0) {
        const copy = { ...prev };
        delete copy[lastKey];
        return copy;
      }
      return { ...prev, [lastKey]: { ...current, qty: nextQty } };
    });
  };

  // For non-segmented products, toggleSelect adds/removes the single entry for that group_id; for segmented products, toggleSelect opens the config modal to add a new entry (if not selected) or clears all entries for that group_id (if already selected)
  const toggleSelect = (p) => {
    const idKey = p.group_id || p.id;
    // 1) lo agrega si no estaba
    setSelectedMap((prev) => {
      if (prev[idKey]) return prev;
      return {
        ...prev,
        [idKey]: {
          signature: `simple:${idKey}::n=`,
          group_id: idKey,
          name: p.name,
          base_price: Number(p.price || 0),
          modifiers: [],
          modifiers_total: 0,
          price: Number(p.price || 0),
          qty: 1,
          note: "",
          kitchen_action: "send_to_kitchen",
        },
      };
    });

    // 2) abre modal nota
    setNoteKey(String(idKey));
    setNoteValue("");
    return;
  };

  // For non-segmented products, inc/dec directly by group_id; for segmented, handle separately
  const incQty = (id) => {
    setSelectedMap((prev) => ({
      ...prev,
      [id]: { ...prev[id], qty: (prev[id]?.qty || 1) + 1 },
    }));
  };

  const decQty = (id) => {
    setSelectedMap((prev) => {
      const current = prev[id];
      if (!current) return prev;

      const nextQty = (current.qty || 1) - 1;
      if (nextQty <= 0) {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      }

      return { ...prev, [id]: { ...current, qty: nextQty } };
    });
  };
  // Compute total price of selected items
  const total = useMemo(() => {
    return selectedItems.reduce((s, it) => s + Number(it.price || 0) * Number(it.qty || 1), 0);
  }, [selectedItems]);

  // Filtrar productos por búsqueda
  const filteredProducts = useMemo(() => {
    if (!search.trim()) return products;
    return products.filter(p =>
      (p.name || "").toLowerCase().includes(search.trim().toLowerCase())
    );
  }, [products, search]);


  return (
    <ModalShell
      title={title}
      onClose={onClose}
      footer={
        <>
          {step === "select" ? (
            <>
              <div className="ord-footer">
                {/* CANCELAR */}
                <button
                  className="ord-btn ord-btn-secondary"
                  type="button"
                  onClick={onClose}
                >
                  Cancelar
                </button>

                <button
                  className="ord-btn ord-btn-primary"
                  type="button"
                  disabled={selectedItems.length === 0}
                  onClick={() => setStep("review")}
                >
                  <i className="bi bi-check-lg" /> Guardar
                </button>

              </div>
            </>
          ) : (
            <> <div className="ord-footer">
              <button type="button" className="ord-btn ord-btn-secondary" onClick={() => setStep("select")}>
                Volver
              </button>

              <button
                type="button"
                className="ord-btn ord-btn-primary"
                disabled={selectedItems.length === 0}
                onClick={() => {
                  onConfirm(selectedItems);
                  onClose();
                }}
              >
                {confirmText} (${total.toFixed(2)})
              </button>
            </div>

            </>
          )}
        </>
      }

    >
      <div style={{ marginBottom: 10, color: "var(--text-secondary)" }}>{description}</div>

      {/** Review step */}
      {step === "review" && (
        <div className="ord-review">
          <div className="ord-review-title">Productos incluidos en la orden</div>

          <div className="ord-list">
            {selectedItems.map((it) => (
              <div key={it.signature} className="ord-row ord-row-review">
                <div className="ord-row-left">
                  <div className="ord-emoji">🍽️</div>
                  <div className="ord-item-main">
                    <div className="ord-name">{it.name}</div>

                    {/* Modifiers */}
                    {Array.isArray(it.modifiers) && it.modifiers.length > 0 && (
                      <div className="ord-modifiers">
                        {it.modifiers.map((seg) => {
                          const names = (seg.selections || []).map((s) => s.name).filter(Boolean).join(", ");
                          if (!names) return null;
                          return (
                            <div key={seg.segment_id}>
                              <strong>{seg.name}:</strong> {names}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Note */}
                    {it.note ? (
                      <div className="ord-note">
                        <strong>Nota:</strong> {it.note}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="ord-row-right">
                  <div className="ord-price">
                    ${(Number(it.price || 0) * Number(it.qty || 1)).toFixed(2)}
                  </div>

                  {/* ✅ Switch send_to_kitchen */}
                  <label className="ord-kitchen-switch">
                    <input
                      type="checkbox"
                      checked={it.send_to_kitchen === "send_to_kitchen"}
                      onChange={(e) => {
                        const val = e.target.checked;
                        setSelectedMap((prev) => {
                          const copy = { ...prev };
                          // ojo: it.signature es el key real para items configurados
                          const key = Object.keys(copy).find((k) => copy[k]?.signature === it.signature) || it.signature;
                          if (!copy[key]) return prev;
                          copy[key] = { ...copy[key], send_to_kitchen: val ? "send_to_kitchen" : "hold" };
                          return copy;
                        });
                      }}
                    />
                    <span className="track" />
                    {it.send_to_kitchen === "send_to_kitchen" ? "Enviar a cocina" : "Mantener en espera"}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/** Product grid */}
      {step === "select" && (
        <div className="row g-2">
          <div className="ord-search-sticky" >
            <div className="ord-search">
              <span className="ord-search-icon" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="7" />
                  <path d="m21 21-4.3-4.3" />
                </svg>
              </span>
              <input
                id="searchInput"
                spellCheck="false"
                className="ord-search-input"
                type="text"
                placeholder="Productos..."
                onChange={e => setSearch(e.target.value)}
              />
            </div>
          </div>
          {filteredProducts.map((p) => {
            const id = p.group_id || p.id;

            // ✅ Count how many times this product (group_id) is selected in selectedMap
            const selectedCountForProduct = Object.values(selectedMap).reduce((acc, it) => {
              if (String(it.group_id) === String(id)) return acc + (Number(it.qty || 1));
              return acc;
            }, 0);

            const picked = selectedMap[id];
            const checked = selectedCountForProduct > 0;

            return (
              <div key={id} className="col-12 col-sm-6 col-md-6">
                <button
                  type="button"
                  className={`ord-card-check ${checked ? "is-checked" : ""}`}
                  onClick={() => {
                    const hasSegments = Array.isArray(p.segments) && p.segments.length > 0;

                    if (!hasSegments) {
                      toggleSelect(p);
                      return;
                    }

                    // Segmented product: click toggles between open-config and clear
                    if (checked) {
                      clearProductSelections(id);
                      return;
                    }

                    setConfigProduct(p);
                  }}
                >
                  {/* Checkbox UI */}
                  <div className={`ord-check-dot ${checked ? "on" : ""}`}>
                    {checked ? "✓" : ""}
                  </div>

                  <div className="ord-card-title">{p.name}</div>
                  <div className="ord-card-desc">{p.description}</div>

                  <div className="ord-card-footer">
                    <div className="ord-price">${Number(p.price || 0).toFixed(2)}</div>

                    {/* Qty controls only visible when selected */}
                    {checked ? (
                      <div
                        className="ord-qty"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <button type="button" className="ord-qty-btn" onClick={() => decQtyForProduct(id, Array.isArray(p.segments) && p.segments.length > 0)}>
                          -
                        </button>
                        <div className="ord-qty-val">{selectedCountForProduct}</div>
                        <button type="button" className="ord-qty-btn" onClick={() => incQtyForProduct(id, Array.isArray(p.segments) && p.segments.length > 0)}>
                          +
                        </button>
                      </div>
                    ) : (
                      <div className="ord-qty-hint">Seleccionar</div>
                    )}
                  </div>
                </button>
              </div>
            );
          })}
        </div>
      )}


      {/* Config modal for products with segments */}
      {configProduct && (
        <ConfigureProductModal
          product={configProduct}
          onClose={() => setConfigProduct(null)}
          onConfirm={(configuredLine) => {
            // configuredLine ya viene con signature único
            setSelectedMap((prev) => {
              const key = configuredLine.signature;
              const prevLine = prev[key];

              // si ya existe la misma config, suma qty
              if (prevLine) {
                return {
                  ...prev,
                  [key]: {
                    ...prevLine, qty: Number(prevLine.qty || 1) + Number(configuredLine.qty || 1), note: String(prevLine.note || "").trim(),
                    kitchen_action: "send_to_kitchen",
                  },
                };
              }

              return { ...prev, [key]: configuredLine };
            });

            setConfigProduct(null);
          }}
        />
      )}
      {/* Note modal for products without segments (or for the last config of a segmented product) */}
      {noteKey && (
        <ModalShell
          title="Nota del producto"
          onClose={() => setNoteKey(null)}
          footer={
            <>



              <div className="ord-footer">

                <button type="button" className="ord-btn ord-btn-secondary" onClick={onClose}>
                  Omitir
                </button>
                <button
                  type="button"
                  className="ord-btn ord-btn-primary"
                  onClick={() => {
                    const clean = String(noteValue || "").trim();
                    setSelectedMap((prev) => {
                      const line = prev[noteKey];
                      if (!line) return prev;
                      const sig = `simple:${line.group_id}::n=${encodeURIComponent(clean)}`;
                      const updated = { ...line, note: clean, signature: sig };
                      const copy = { ...prev };
                      delete copy[noteKey];
                      copy[sig] = updated; // ✅ ojo: cambiamos key a signature para evitar merges raros
                      return copy;
                    });
                    setNoteKey(null);
                  }}
                >
                  Guardar nota
                </button>
              </div>
            </>
          }
        >
          <div className="rfm-form-group">
            <label className="rfm-form-label">Escribe una nota (opcional)</label>
            <textarea className="rfm-form-input" rows={3} value={noteValue} onChange={(e) => setNoteValue(e.target.value)} />
          </div>
        </ModalShell>
      )}

    </ModalShell>
  );
}

/* ===========================
   CONFIGURE PRODUCT (generic)
=========================== */
// This modal handles products with segments (modifiers); it builds a unique signature based on selected options to allow multiple configurations of the same product
function ConfigureProductModal({ product, onClose, onConfirm }) {
  const segments = Array.isArray(product?.segments) ? product.segments : [];
  const [step, setStep] = useState("segments"); // segments | note
  const [note, setNote] = useState("");
  // selections: { [segment_id]: option[] }
  const [selections, setSelections] = useState(() => {
    const init = {};
    segments.forEach((seg) => {
      const items = Array.isArray(seg.items) ? seg.items : [];
      if (items.length === 0) return; // ✅ no guardar selections para segmentos sin items

      // Detect default item id
      let defaultId = null;

      if (Array.isArray(seg.default_items) && seg.default_items.length > 0) {
        defaultId = seg.default_items[0]?.item_id ?? null;
      } else if (seg.segment_item_id_default) {
        defaultId = seg.segment_item_id_default;
      }

      // Find default in items, else first option
      const defaultOpt = defaultId
        ? items.find((i) => String(i.item_id) === String(defaultId))
        : null;

      const firstOpt = items[0] || null;

      const initialPick = defaultOpt || firstOpt;

      if (!initialPick) return;

      if (seg.type === "UNIQ") {
        init[seg.segment_id] = [initialPick];
      } else {
        // MULT: start with one preselected option (default/first)
        init[seg.segment_id] = [initialPick];
      }
    });

    return init;
  });

  const toggleOption = (seg, opt) => {
    setSelections((prev) => {
      const copy = { ...prev };
      const sid = seg.segment_id;
      const current = Array.isArray(copy[sid]) ? [...copy[sid]] : [];

      if (seg.type === "UNIQ") {
        copy[sid] = [opt];
        return copy;
      }

      // MULT
      const exists = current.some((x) => String(x.item_id) === String(opt.item_id));
      if (exists) {
        copy[sid] = current.filter((x) => String(x.item_id) !== String(opt.item_id));
        return copy;
      }

      const max = Number(seg.maximumCount || 999);
      if (current.length >= max) return copy;

      copy[sid] = [...current, opt];
      return copy;
    });
  };

  const modifiersTotal = useMemo(() => {
    return Object.values(selections)
      .flat()
      .reduce((s, o) => s + Number(o.price || 0), 0);
  }, [selections]);

  const basePrice = Number(product?.price || 0);
  const unitPrice = basePrice + modifiersTotal;

  const validationErrors = useMemo(() => {
    const errs = [];
    segments.forEach((seg) => {
      // If segment has no items, skip validation (also avoids errors)
      const items = Array.isArray(seg.items) ? seg.items : [];
      if (items.length === 0) return;
      // For each segment, check if the number of selected options meets min/max
      const sid = seg.segment_id;
      const chosen = Array.isArray(selections[sid]) ? selections[sid] : [];
      const min = Number(seg.minimumCount || 0);
      const max = Number(seg.maximumCount || 999);

      if (chosen.length < min) errs.push(`Selecciona al menos ${min} en "${seg.name}".`);
      if (chosen.length > max) errs.push(`Selecciona máximo ${max} en "${seg.name}".`);
    });
    return errs;
  }, [segments, selections]);

  const signature = useMemo(() => {
    const parts = segments
      .filter((seg) => Array.isArray(seg.items) && seg.items.length > 0)
      .map((seg) => {
        const sid = seg.segment_id;
        const ids = (selections[sid] || []).map((x) => x.item_id).sort((a, b) => Number(a) - Number(b));
        return `${sid}=[${ids.join(",")}]`;
      });

    const n = encodeURIComponent(String(note || "").trim());
    return `cfg:${product.group_id}::${parts.join("|")}::n=${n}`;
  }, [product?.group_id, segments, selections, note]);

  const confirm = () => {
    if (validationErrors.length > 0) return;

    const modifiers = segments
      .filter(
        (seg) =>
          Array.isArray(seg.items) &&
          seg.items.length > 0
      )
      .map((seg) => {
        const sid = seg.segment_id;

        const chosen = Array.isArray(selections[sid])
          ? selections[sid]
          : [];

        if (chosen.length === 0) return null;

        return {
          segment_id: sid,
          name: seg.name,
          type: seg.type,
          minimumCount: seg.minimumCount,
          maximumCount: seg.maximumCount,

          selections: chosen.map((o) => ({
            ...o,
            item_id: o.item_id,
            name: o.name,
            price: Number(o.price || 0),
          })),
        };
      })
      .filter(Boolean);

    onConfirm?.({
      signature,
      group_id: product.group_id,
      name: product.name,
      qty: 1,
      base_price: basePrice,
      modifiers,
      modifiers_total: modifiersTotal,
      price: unitPrice,

      // OPCIONAL
      note: String(note || "").trim(),

      kitchen_action:
        product.kitchen_action || "send_to_kitchen",
    });
  };
  const [stepOption, setStepOption] = useState("options");
  // const [note, setNote] = useState("");

  const handleContinue = () => {
    // Si existen errores de validación, no avanzar
    if (validationErrors.length > 0) {
      return;
    }
    setStepOption("note");
  };

  const handleBack = () => {
    setStepOption("options");
  };

  const handleConfirm = () => {
    confirm();
  };


  return (
    <ModalShell
      title={product?.name || "Configurar"}
      subtitle={`Base $${basePrice.toFixed(2)}  •  Total $${unitPrice.toFixed(2)}`}
      img={product?.img}
      onClose={onClose}
      footer={
        <>
          <div className="ord-footer">

            {/* PASO 1 → PASO 2 */}
            {stepOption === "options" && (

              <>
                {/* CANCELAR */}
                <button
                  className="ord-btn ord-btn-secondary"
                  type="button"
                  onClick={onClose}
                >
                  Cancelar
                </button>
                <button
                  className="ord-btn ord-btn-primary"
                  type="button"
                  onClick={handleContinue}
                  disabled={validationErrors.length > 0}
                >
                  Continuar
                </button>
              </>

            )}


            {/* PASO 2 */}
            {stepOption === "note" && (
              <>
                <button
                  className="ord-btn ord-btn-secondary"
                  type="button"
                  onClick={handleBack}
                >
                  Atrás
                </button>

                <button
                  className="ord-btn ord-btn-primary"
                  type="button"
                  onClick={handleConfirm}
                >
                  Agregar(${unitPrice.toFixed(2)})
                </button>
              </>
            )}

          </div>
        </>
      }
    >

      {validationErrors.length > 0 && (
        <div style={{ background: "rgba(255,0,0,.06)", border: "1px solid rgba(255,0,0,.15)", padding: 10, borderRadius: 12, marginBottom: 12 }}>
          {validationErrors.map((e, i) => (
            <div key={i} style={{ color: "#b00020", fontWeight: 700, fontSize: 13 }}>
              • {e}
            </div>
          ))}
        </div>
      )}
      <div className="ord-steps">

        <div className={`ord-step ${stepOption === "options" ? "active" : "completed"}`}>
          <div className="ord-step-number">
            {stepOption === "note" ? "✓" : "1"}
          </div>

          <div className="ord-step-info">
            <span>Opciones</span>
            <small>Selecciona tus productos</small>
          </div>
        </div>

        <div className="ord-step-line" />

        <div className={`ord-step ${stepOption === "note" ? "active" : ""}`}>
          <div className="ord-step-number">
            2
          </div>

          <div className="ord-step-info">
            <span>Nota</span>
            <small>Personaliza tu pedido</small>
          </div>
        </div>

      </div>

      {stepOption === "options" && (

        <>
          {segments.map((seg) => {
            const items = Array.isArray(seg.items) ? seg.items : [];

            if (items.length === 0) return null;

            const chosen = Array.isArray(selections[seg.segment_id])
              ? selections[seg.segment_id]
              : [];

            const max = Number(seg.maximumCount || 999);

            return (
              <div key={seg.segment_id} className="ord-seg">

                <div className="ord-seg-head">
                  <div className="ord-seg-name">
                    {seg.name}
                  </div>

                  <div className="ord-seg-rule">
                    {seg.type === "UNIQ"
                      ? "Selecciona 1"
                      : `Selecciona hasta ${max}`}
                    {" • "}
                    Elegidos {chosen.length}
                  </div>
                </div>
                {/* 
                <div className="ord-seg-grid">
                  {items.map((opt) => {
                    const active = chosen.some(
                      (x) => String(x.item_id) === String(opt.item_id)
                    );

                    const isDisabled =
                      !active &&
                      seg.type === "MULT" &&
                      chosen.length >= max;

                    return (
                      <button
                        key={opt.item_id}
                        type="button"
                        disabled={isDisabled}
                        onClick={() => toggleOption(seg, opt)}
                        className={`ord-opt${active ? " is-active" : ""}`}
                      >
                        <div className="ord-opt-top">                      
                          <span className="ord-opt-name">
                            {opt.name}
                          </span>

                          <span className="ord-opt-price">
                            +${Number(opt.price || 0).toFixed(2)}
                          </span>
                        </div>

                        {opt.description ? (
                          <div className="ord-opt-desc">
                            {opt.description} 
                          </div>
                        ) : null}
                      </button>
                    );
                  })}
                </div> */}

                <OrdSegOptions
                  items={items}
                  chosen={chosen}
                  seg={seg}
                  max={max}
                  toggleOption={toggleOption}
                />

              </div>
            );
          })}

        </>
      )}


      {stepOption === "note" && (
        <div style={{ marginBottom: 14 }}>

          <div
            style={{
              fontWeight: 900,
              marginBottom: 6,
            }}
          >
            Nota del producto
            <span
              style={{
                fontWeight: 500,
                marginLeft: 6,
                opacity: 0.6,
              }}
            >
              (opcional)
            </span>
          </div>

          <textarea
            className="rfm-form-input"
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Ej: Sin cebolla, salsa aparte…"
          />

        </div>
      )}

    </ModalShell>
  );
}

function OrdSegOptions({ items, chosen, seg, max, toggleOption }) {
  const scrollRef = React.useRef(null);
  const { canPrev, canNext, scrollPrev, scrollNext } = useScrollArrows(scrollRef);

  return (
    <div className="ord-seg-wrap">
      {canPrev && (
        <button type="button" className="ord-seg-arrow left" onClick={scrollPrev} aria-label="Anterior">
          <i className="bi bi-chevron-left" />
        </button>
      )}
      <div className="ord-seg-scroll" ref={scrollRef}>
        {items.map((opt) => {
          const active = chosen.some((x) => String(x.item_id) === String(opt.item_id));
          const isDisabled = !active && seg.type === "MULT" && chosen.length >= max;
          return (
            <button
              key={opt.item_id}
              type="button"
              disabled={isDisabled}
              onClick={() => toggleOption(seg, opt)}
              className={`ord-opt${active ? " is-active" : ""}`}
            >
              <div className="ord-opt-media">
                {opt.image || opt.image_url || opt.img ? (
                  <img src={opt.image || opt.image_url || opt.img} alt={opt.name} />
                ) : (
                  <span className="ph"><i className="bi bi-egg-fried" /></span>
                )}
              </div>
              <span className="ord-opt-check"><i className="bi bi-check-lg" /></span>
              <span className="ord-opt-name">{opt.name}</span>
              {opt.description ? <div className="ord-opt-desc">{opt.description}</div> : null}
              <span className="ord-opt-price">+${Number(opt.price || 0).toFixed(2)}</span>
            </button>
          );
        })}
      </div>
      {canNext && (
        <button type="button" className="ord-seg-arrow right" onClick={scrollNext} aria-label="Siguiente">
          <i className="bi bi-chevron-right" />
        </button>
      )}
    </div>
  );
}

/* ===========================
   ORDER DETAILS (generic)
=========================== */
// Business-facing status for a line, replacing the raw line_status/kitchen_action enums (DRAFT/
// SUBMITTED/hold/send_to_kitchen are internal vocabulary the waiter shouldn't have to translate).
// Sent takes priority since it's terminal from the waiter's point of view; otherwise DRAFT means the
// customer is still editing on their phone (nothing to act on yet), and anything else submitted-but-
// not-sent is the actionable "ready to send" state.
const getLineBusinessStatus = (line) => {
  // Pre-pago partial payment (Fase 5) - payment_status is additive and only ever populated for
  // PRE_PAY orders (see services/tableSessionPayments.js on the backend), so these checks are no-ops
  // for every other order. Takes priority over kitchen_action since for pre-pago, "enviado a cocina"
  // and "pagado" are the same event (confirmPaymentClaim flips both together) - showing "Pagado" is
  // more useful to the waiter than the generic "enviado a cocina".
  if (line.payment_status === "PAID") {
    return { label: "Pagado", className: "paid" };
  }
  if (line.payment_status === "PAYMENT_PENDING") {
    return { label: "Cobrando", className: "charging" };
  }
  if (line.kitchen_action === "send_to_kitchen") {
    return { label: "Enviado a cocina", className: "sent" };
  }
  if (line.line_status === "DRAFT") {
    return { label: "Editando (cliente)", className: "editing" };
  }
  return { label: "Pendiente de enviar", className: "pending" };
};

// Pre-pago (Fase 5): live paid/pending totals from the raw order document's own lines/payments[] -
// same simple sum-with-tax math tableSessionOrderSnapshot.js#sanitizeLine uses on the backend, kept
// here since the POS reads the raw TempOrder doc directly rather than the ecommerce-facing snapshot.
const computeLineTotal = (line) => {
  const amount = Number(line.amount ?? line.qty ?? 1) || 0;
  const price = Number(line.price) || 0;
  const discount = Number(line.discount) || 0;
  const taxTotal = (Array.isArray(line.taxes) ? line.taxes : []).reduce((sum, tax) => sum + (Number(tax.total) || 0), 0);
  return Math.max(0, amount * price - discount) + taxTotal;
};

function OrderDetailsModal({ table, orderId, onClose, onAddMore, onSendToPay, onOrdersChanged, onPrintComanda, onOpenPosCharge }) {
  const order = useMemo(() => {
    return (table.table_orders || []).find((o) => String(o.id) === String(orderId)) || null;
  }, [table, orderId]);
  const [backendOrder, setBackendOrder] = useState(null);

  // Post-pago e-commerce: el cliente pide desde su celular y nada llega a la impresora de cocina por
  // si solo (el backend no imprime) - al mandar lineas a cocina desde aqui el POS imprime la comanda.
  // SI lanza si falla: antes se tragaba el error (la linea quedaba marcada "enviada" en el backend
  // aunque la comanda nunca se imprimiera de verdad, sin ninguna forma de saberlo con certeza). Dejar
  // que se propague es lo que permite a sendSingleItemToKitchen/sendAllPendingItemsToKitchen revertir
  // kitchen_action cuando la impresion realmente fallo.
  const printComandaForOrder = async (orderIdReal, amountItems) => {
    await onPrintComanda?.({
      orderId: orderIdReal,
      transactionCode: backendOrder?.transaction_code || order?.transaction_code || backendOrder?.code || "",
      tableName: backendOrder?.table_name || table?.number || 0,
      amountItems,
    });
  };
  const [loading, setLoading] = useState(false);
  const [sendingItemId, setSendingItemId] = useState(null);

  const [draftGroups, setDraftGroups] = useState([]);

  // Pre-pago partial payment (Fase 5): order_source is set once at order creation (see
  // getOrderSourceForSession on the backend) and never changes, so this is a reliable, order-scoped
  // check - unlike payment_mode (a table_session-level field this component never fetches).
  const isPrepayOrder = String(backendOrder?.order_source || "").toUpperCase() === "ECOMMERCE_TABLE_PREPAY";

  // En pre-pago el cobro es lo que libera una linea a cocina: mandar una sin pagar saca la comanda sin cobro
  // (y si luego se anula o se cobra distinto, queda un producto preparado que nadie pago). El servidor ya
  // envia a cocina las lineas al confirmarse su pago, asi que aqui solo se permite lo ya pagado.
  const canSendLineToKitchen = (line) => !isPrepayOrder || line?.payment_status === "PAID";

  // Waiter-controlled payment gate (ecommerce Pagar button): only meaningful for orders that came
  // from a table_session (the customer's own phone), a POS-only order has no ecommerce side to
  // authorize. Starts from whatever the order document already carries, so re-opening this modal
  // after a page refresh still reflects it instead of resetting to "not authorized".
  //
  // Never applies to a pre-pago order (isPrepayOrder) - authorize-payment/sendAllPendingItemsToKitchen
  // below are POST_PAY-only concepts: the former would prematurely lock the whole shared account from
  // further ordering (see assertCollaborativeAccess on the backend, gated on
  // session.payment.authorized, which for pre-pago must only ever flip inside finalizeTableAccount),
  // and the latter would force an unpaid line to the kitchen, bypassing the payment gate entirely.
  // Pre-pago's own account/closure view is the "Ver cuenta pre-pago" panel below instead.
  const [authorizingPayment, setAuthorizingPayment] = useState(false);
  const [paymentAuthorized, setPaymentAuthorized] = useState(false);

  const authorizeOnlinePayment = async () => {
    const sessionUuid = backendOrder?.table_session_uuid;
    if (!sessionUuid || authorizingPayment || isPrepayOrder) return;

    setAuthorizingPayment(true);
    try {
      // Nada pendiente se queda sin cobrar una vez el cliente puede pagar desde su celular.
      await sendAllPendingItemsToKitchen();
      await TableSessionsFetchAPI.authorizePayment(sessionUuid, localStorage.getItem("x-access-machine-token"));
      setPaymentAuthorized(true);
      AlertSmall("El cliente ya puede pagar desde su celular", "success");
    } catch (err) {
      console.error(err);
      ErrorAlert("", "No fue posible habilitar el pago en linea", "error");
    } finally {
      setAuthorizingPayment(false);
    }
  };

  // ---- Pre-pago: "ver cuenta" panel + force-finalize (Fase 5) ----
  const [showPrepayAccountPanel, setShowPrepayAccountPanel] = useState(false);
  const [forceFinalizing, setForceFinalizing] = useState(false);
  // Solo se muestra cuando hay productos pendientes al tocar "Cerrar cuenta": deja elegir, por linea,
  // eliminarla o cobrarla de verdad en vez de que el saldo se registre solo como efectivo.
  const [showClosePicker, setShowClosePicker] = useState(false);
  const [pendingSelection, setPendingSelection] = useState(() => new Set());
  const [resolvingPending, setResolvingPending] = useState(false);
  const [voidingAccount, setVoidingAccount] = useState(false);

  const prepayPaidTotal = useMemo(() => (
    isPrepayOrder ? draftGroups.filter((g) => g.payment_status === "PAID").reduce((sum, g) => sum + computeLineTotal(g), 0) : 0
  ), [isPrepayOrder, draftGroups]);
  const prepayPendingBalance = useMemo(() => (
    isPrepayOrder
      ? draftGroups.filter((g) => g.line_status !== "CANCELLED" && g.payment_status !== "PAID").reduce((sum, g) => sum + computeLineTotal(g), 0)
      : 0
  ), [isPrepayOrder, draftGroups]);
  const prepayPayments = Array.isArray(backendOrder?.payments) ? backendOrder.payments : [];

  // Lineas que de verdad se pueden elegir en el picker: UNPAID puro (ni pagadas ni con un cobro ya en
  // curso - esas ultimas se liberan/confirman con el flujo normal, nunca se eliminan por debajo).
  const actionablePendingLines = useMemo(() => (
    isPrepayOrder ? draftGroups.filter((g) => g.line_status !== "CANCELLED" && g.payment_status === "UNPAID") : []
  ), [isPrepayOrder, draftGroups]);
  const pendingSelectionTotal = useMemo(() => (
    actionablePendingLines.filter((g) => pendingSelection.has(g.line_uuid)).reduce((sum, g) => sum + computeLineTotal(g), 0)
  ), [actionablePendingLines, pendingSelection]);

  const togglePendingSelection = (lineUuid) => {
    setPendingSelection((prev) => {
      const next = new Set(prev);
      if (next.has(lineUuid)) next.delete(lineUuid); else next.add(lineUuid);
      return next;
    });
  };

  // Cierra directo (nada pendiente y algo real ya se pago) - el camino de siempre, sin preguntar nada.
  const finalizeAccountDirectly = async () => {
    const sessionUuid = backendOrder?.table_session_uuid;
    if (!sessionUuid || forceFinalizing) return;

    setForceFinalizing(true);
    try {
      await TableSessionsFetchAPI.forceFinalizeAccount(sessionUuid, localStorage.getItem("x-access-machine-token"));
      AlertSmall("Cuenta cerrada correctamente", "success");
      setShowPrepayAccountPanel(false);
      // The backend deleted the TempOrder behind this account - without this, table.table_orders
      // (owned by Reservation.jsx, not this modal) stays stale until something else happens to
      // refetch it, so this same closed order kept showing up as "open" until the offcanvas was
      // closed and reopened.
      await onOrdersChanged?.(table.id);
      onClose?.();
    } catch (err) {
      console.error(err);
      ErrorAlert("", err?.response?.data?.error || "No fue posible cerrar la cuenta", "error");
    } finally {
      setForceFinalizing(false);
    }
  };

  // ---- "Personalizar factura": nombre/RUC/DV con los que se emite la factura al cerrar la cuenta ----
  // Los lee de la propia orden (backendOrder, que se refresca por socket) - tambien refleja lo que el
  // cliente haya puesto desde su carrito en el ecommerce.
  const [showInvoiceForm, setShowInvoiceForm] = useState(false);

  const isBlankFiscal = (value) => ["", "0", "0-000-000", null, undefined].includes(value);
  const savedInvoice = backendOrder?.invoice_customized
    ? {
      client_name: backendOrder.client_name || "",
      ruc: isBlankFiscal(backendOrder.client_ruc) ? "" : String(backendOrder.client_ruc),
      dv: isBlankFiscal(backendOrder.client_dv) ? "" : String(backendOrder.client_dv),
    }
    : null;

  // RfmCustomizeInvoiceModal hace la validacion con la DGI (mismo flujo que el Centro de Pagos); aqui solo se
  // guarda en la cuenta. Si falla, el error se propaga al modal para mostrarlo ahi.
  const persistInvoiceData = async (data) => {
    const sessionUuid = backendOrder?.table_session_uuid;
    if (!sessionUuid) throw new Error("La cuenta no tiene sesion de mesa");
    const resp = await TableSessionsFetchAPI.setInvoiceData(
      sessionUuid,
      { ...data, account_uuid: backendOrder?.account_uuid || undefined },
      localStorage.getItem("x-access-machine-token")
    );
    // El socket (tableSessionOrderUpdated) ya refresca backendOrder; esto solo adelanta el cambio.
    const saved = resp?.data?.data;
    setBackendOrder((prev) => (prev ? {
      ...prev,
      invoice_customized: Boolean(saved?.customized),
      client_name: saved?.customized ? saved.client_name : "Cliente generico",
      client_ruc: saved?.ruc || "0",
      client_dv: saved?.dv || "0",
    } : prev));
    return saved;
  };

  const saveInvoiceData = async (data) => {
    await persistInvoiceData(data);
    AlertSmall("Factura personalizada", "success");
    setShowInvoiceForm(false);
  };

  const removeInvoiceData = async () => {
    await persistInvoiceData({ client_name: "", ruc: "", dv: "" });
    AlertSmall("Factura a consumidor final", "success");
    setShowInvoiceForm(false);
  };

  // Anula la cuenta completa (sin factura, ni siquiera de $0) - unica opcion cuando literalmente no se
  // ha cobrado nada, ya que forceFinalizeAccount rechaza facturar sin ningun pago confirmado.
  const handleVoidAccount = async () => {
    const sessionUuid = backendOrder?.table_session_uuid;
    if (!sessionUuid || voidingAccount) return;

    const confirmed = await RfmConfirm(
      "Esta cuenta no tiene ningún pago registrado. Se eliminará por completo y la mesa quedará libre. Esta acción no se puede deshacer. ¿Continuar?",
      "Anular cuenta"
    );
    if (!confirmed) return;

    setVoidingAccount(true);
    try {
      await TableSessionsFetchAPI.voidPrepayAccount(sessionUuid, localStorage.getItem("x-access-machine-token"));
      AlertSmall("Cuenta anulada", "success");
      setShowClosePicker(false);
      setShowPrepayAccountPanel(false);
      await onOrdersChanged?.(table.id);
      onClose?.();
    } catch (err) {
      console.error(err);
      ErrorAlert("", err?.response?.data?.error || "No fue posible anular la cuenta", "error");
    } finally {
      setVoidingAccount(false);
    }
  };


  // "Cerrar cuenta": decide el camino segun si hay pendientes y si algo real ya se cobro.
  // El "¿estas seguro?" solo sale cuando de verdad se va a cerrar la cuenta (finalizeAccountDirectly):
  // con pendientes el siguiente paso es el selector de productos (eliminar/cobrar), que ya es su propia
  // confirmacion, y anular la cuenta pide la suya (handleVoidAccount).
  const handleCloseAccountClick = async () => {
    if (prepayPendingBalance > 0) {
      setPendingSelection(new Set(actionablePendingLines.map((g) => g.line_uuid)));
      setShowClosePicker(true);
      return;
    }
    if (prepayPaidTotal === 0) {
      // Nada pendiente y nada pagado (cuenta vacia/todo cancelado): forceFinalizeAccount fallaria con
      // NO_CONFIRMED_PAYMENTS al no tener nada que facturar - anular es la unica salida.
      handleVoidAccount();
      return;
    }
    const confirmed = await RfmConfirm(
      "Vas a cerrar la cuenta de esta mesa. Esta acción no se puede deshacer. ¿Deseas continuar?",
      "Cerrar cuenta"
    );
    if (!confirmed) return;
    finalizeAccountDirectly();
  };

  const handleDeleteSelectedPending = async () => {
    const sessionUuid = backendOrder?.table_session_uuid;
    const lineUuids = Array.from(pendingSelection);
    if (!sessionUuid || lineUuids.length === 0 || resolvingPending) return;

    const confirmed = await RfmConfirm(
      `Se eliminarán ${lineUuids.length} producto${lineUuids.length === 1 ? "" : "s"} sin cobrarlos. Esta acción no se puede deshacer. ¿Continuar?`,
      "Eliminar productos"
    );
    if (!confirmed) return;

    setResolvingPending(true);
    try {
      await TableSessionsFetchAPI.cancelPendingLines(sessionUuid, lineUuids, localStorage.getItem("x-access-machine-token"));
      AlertSmall("Productos eliminados", "success");
      // El propio socket de este modal (ver el useEffect de tableSessionOrderUpdated) actualiza
      // draftGroups solo en cuanto llega el broadcast del backend - aqui solo se limpia la seleccion.
      setPendingSelection(new Set());
    } catch (err) {
      console.error(err);
      ErrorAlert("", err?.response?.data?.error || "No fue posible eliminar los productos", "error");
    } finally {
      setResolvingPending(false);
    }
  };

  const handlePaySelectedPending = async () => {
    const sessionUuid = backendOrder?.table_session_uuid;
    const lineUuids = Array.from(pendingSelection);
    if (!sessionUuid || lineUuids.length === 0 || resolvingPending || !onOpenPosCharge) return;

    setResolvingPending(true);
    try {
      const response = await TableSessionsFetchAPI.staffClaimPendingLines(sessionUuid, lineUuids, localStorage.getItem("x-access-machine-token"));
      const data = response?.data?.data;
      if (!data?.payment_attempt_id) throw new Error("Respuesta invalida del servidor");

      // Mismo shape que arma handleChargePosPayment en Reservation.jsx a partir de una solicitud del
      // cliente (tableSessionPhysicalPaymentRequested) - aqui el mesero es quien inicia el cobro, pero
      // el Centro de Pagos que se abre es exactamente el mismo.
      onOpenPosCharge({
        session_uuid: sessionUuid,
        payment_attempt_id: data.payment_attempt_id,
        calculation_id: data.calculation_id,
        amount: data.total,
        items: data.items || [],
        table_id: table.id,
        table_name: table.name || table.number || table.id
      });
      setShowClosePicker(false);
      setShowPrepayAccountPanel(false);
    } catch (err) {
      console.error(err);
      ErrorAlert("", err?.response?.data?.error || "No fue posible iniciar el cobro", "error");
    } finally {
      setResolvingPending(false);
    }
  };

  const [sendingToPay, setSendingToPay] = useState(false);
  const handleSendToPay = async () => {
    if (sendingToPay || isPrepayOrder) return;
    setSendingToPay(true);
    try {
      // Igual que al habilitar el pago en linea: todo lo pendiente se manda a cocina antes de
      // mandar la cuenta a cobrar, para que no quede nada sin cocinar/cobrar.
      await sendAllPendingItemsToKitchen();
      onSendToPay?.();
    } catch (err) {
      console.error(err);
      ErrorAlert("", "No fue posible enviar los productos pendientes a cocina", "error");
    } finally {
      setSendingToPay(false);
    }
  };

  // This function is called when user toggles "send to kitchen" for a single item; it performs an optimistic UI update and then sends the full updated groups to backend; if backend fails, it rolls back the UI change for that item  
  const sendSingleItemToKitchen = async (row) => {
    const orderIdReal = backendOrder?._id?.$oid ?? backendOrder?._id ?? orderId;
    const rowId = row?._id?.$oid ?? row?._id;
    if (!orderIdReal || !rowId) return;
    if (!canSendLineToKitchen(row)) return;

    setSendingItemId(String(rowId));

    // Arma el payload completo de groups para el PATCH, con el kitchen_action que se quiera dejar en
    // ESTA fila puntual (el resto conserva el suyo) - se reutiliza tanto para marcar "enviado" como,
    // si la impresion falla de verdad, para revertir a "hold" en el backend (no solo en pantalla).
    const buildGroupsPayload = (kitchenActionForRow) => draftGroups.map((g) => {
      const gid = g?._id?.$oid ?? g?._id;
      const nextAction = String(gid) === String(rowId) ? kitchenActionForRow : (g.kitchen_action || "hold");
      return {
        ...g,
        _id: gid,
        amount: Number(g.amount ?? g.qty ?? 1), // backend use "amount", UI use "qty"; we send both to be safe, but backend will prioritize "amount"
        kitchen_action: nextAction,
        note: String(g.note ?? ""),
      };
    });

    const buildPayload = (groups) => ({
      _id: orderIdReal,
      order_type: backendOrder?.order_type,
      client_name: backendOrder?.client_name,
      localizador: backendOrder?.locator ?? backendOrder?.localizador,
      table_name: backendOrder?.table_name,
      ruc: backendOrder?.client_ruc ?? backendOrder?.ruc,
      dv: backendOrder?.client_dv ?? backendOrder?.dv,
      is_discount_notification: Boolean(backendOrder?.is_discount_notification),
      combos: backendOrder?.combos || [],
      discounts: backendOrder?.discounts || [],
      removed_products: [],
      email_cc: backendOrder?.email_cc || [""],
      groups,
    });

    // 1) Optimistic UI update
    setDraftGroups((prev) =>
      prev.map((g) =>
        String((g?._id?.$oid ?? g?._id)) === String(rowId)
          ? { ...g, kitchen_action: "send_to_kitchen" }
          : g
      )
    );

    let markedSentOnBackend = false;
    try {
      // 2) Backend update: send full groups (preserving _id for each item)
      await PreOrderFetchAPI.updateOrderTempPreOrder(buildPayload(buildGroupsPayload("send_to_kitchen")), localStorage.getItem("x-access-machine-token"));
      markedSentOnBackend = true;
      // Total de lineas de la orden (no solo la que se envia): ver amount_item en printPreOrderFromTables.
      await printComandaForOrder(orderIdReal, draftGroups.length);
    } catch (err) {
      console.error(err);

      // rollback UI si falla
      setDraftGroups((prev) =>
        prev.map((g) =>
          String((g?._id?.$oid ?? g?._id)) === String(rowId)
            ? { ...g, kitchen_action: "hold" }
            : g
        )
      );

      // Sin esto, si el PATCH de arriba si llego a guardarse pero la impresion fallo despues, el
      // backend se quedaba con kitchen_action="send_to_kitchen" para siempre (el proximo refresh
      // mostraba "Enviado a cocina" de nuevo, aunque la comanda nunca haya salido) - el mesero no
      // podia confiar en lo que ve. Revertirlo tambien aqui es lo que deja la fila realmente
      // "Pendiente de enviar" y lista para reintentar.
      if (markedSentOnBackend) {
        try {
          await PreOrderFetchAPI.updateOrderTempPreOrder(buildPayload(buildGroupsPayload("hold")), localStorage.getItem("x-access-machine-token"));
        } catch (revertErr) {
          console.error(revertErr);
        }
      }
      AlertSmall("No se pudo enviar la comanda a imprimir - el producto volvió a quedar pendiente de enviar", "warning");
    } finally {
      setSendingItemId(null);
    }
  };

  // Bulk version of sendSingleItemToKitchen, used before closing out the account (authorizeOnlinePayment /
  // "Enviar a pagar") so nothing pending gets left behind uncharged. Same DRAFT exclusion as the
  // per-row button above (RenderIf on kitchen_action==="hold" && line_status!=="DRAFT") - a line the
  // customer is still actively editing is never force-sent, only lines already submitted by them but
  // still on hold.
  const sendAllPendingItemsToKitchen = async () => {
    const orderIdReal = backendOrder?._id?.$oid ?? backendOrder?._id ?? orderId;
    if (!orderIdReal) return;

    const pendingIds = draftGroups
      .filter((g) => g.kitchen_action === "hold" && g.line_status !== "DRAFT")
      .map((g) => String(g?._id?.$oid ?? g?._id));
    if (pendingIds.length === 0) return;

    setSendingItemId("__all__");

    setDraftGroups((prev) =>
      prev.map((g) =>
        pendingIds.includes(String(g?._id?.$oid ?? g?._id))
          ? { ...g, kitchen_action: "send_to_kitchen" }
          : g
      )
    );

    const updatedGroups = draftGroups.map((g) => {
      const gid = g?._id?.$oid ?? g?._id;
      const shouldSend = pendingIds.includes(String(gid));
      return {
        ...g,
        _id: gid,
        amount: Number(g.amount ?? g.qty ?? 1),
        kitchen_action: shouldSend ? "send_to_kitchen" : (g.kitchen_action === "send_to_kitchen" ? "send_to_kitchen" : "hold"),
        note: String(g.note ?? ""),
      };
    });

    const payloadUpdate = {
      _id: orderIdReal,
      order_type: backendOrder?.order_type,
      client_name: backendOrder?.client_name,
      localizador: backendOrder?.locator ?? backendOrder?.localizador,
      table_name: backendOrder?.table_name,
      ruc: backendOrder?.client_ruc ?? backendOrder?.ruc,
      dv: backendOrder?.client_dv ?? backendOrder?.dv,
      is_discount_notification: Boolean(backendOrder?.is_discount_notification),
      combos: backendOrder?.combos || [],
      discounts: backendOrder?.discounts || [],
      removed_products: [],
      email_cc: backendOrder?.email_cc || [""],
      groups: updatedGroups,
    };

    let markedSentOnBackend = false;
    try {
      await PreOrderFetchAPI.updateOrderTempPreOrder(payloadUpdate, localStorage.getItem("x-access-machine-token"));
      markedSentOnBackend = true;
      await printComandaForOrder(orderIdReal, updatedGroups.length);
    } catch (err) {
      console.error(err);
      setDraftGroups((prev) =>
        prev.map((g) =>
          pendingIds.includes(String(g?._id?.$oid ?? g?._id))
            ? { ...g, kitchen_action: "hold" }
            : g
        )
      );
      // Mismo caso que sendSingleItemToKitchen: si el PATCH ya se guardo pero la impresion fallo
      // despues, hay que revertir tambien el backend - si no, estas lineas quedan "enviadas" para
      // siempre aunque la comanda nunca haya salido.
      if (markedSentOnBackend) {
        try {
          const revertedGroups = updatedGroups.map((g) => (
            pendingIds.includes(String(g._id)) ? { ...g, kitchen_action: "hold" } : g
          ));
          await PreOrderFetchAPI.updateOrderTempPreOrder({ ...payloadUpdate, groups: revertedGroups }, localStorage.getItem("x-access-machine-token"));
        } catch (revertErr) {
          console.error(revertErr);
        }
      }
      throw err;
    } finally {
      setSendingItemId(null);
    }
  };

  // Shared by the initial fetch and the live socket snapshot below - both need the exact same
  // shape (kitchen_action/_id kept, unlike Reservation.jsx's own normalizeBackendOrdersToTableOrders
  // which drops those for the table-grid's lighter "items" view).
  const normalizeGroupsForEditing = (groups) => (Array.isArray(groups) ? groups.map((g) => ({
    ...g,
    _id: g?._id?.$oid ?? g?._id,
    qty: Number(g?.amount ?? 1),
    note: String(g?.note ?? ""),
    kitchen_action: g?.kitchen_action === "send_to_kitchen" ? "send_to_kitchen" : "hold",
    // El spread de arriba ya trae g.segments (shape crudo del backend), pero el render de items de
    // este modal pinta segments/modificadores leyendo it.modifiers (mismo shape que la vista liviana
    // de la grilla de mesas) - sin esto un producto con guarnicion/bebida seleccionable se veia sin
    // ningun detalle debajo, aunque el dato ya estaba ahi.
    modifiers: Array.isArray(g?.segments) && g.segments.length > 0 ? segmentsToModifiers(g.segments) : [],
    // Fase 5/6: ya venian preservados por el spread `...g` (el backend los guarda directo en
    // groups[] - ver app/models/temp_orders.js), se dejan explicitos aqui solo para que el
    // render de abajo no dependa de un detalle de implementacion.
    line_uuid: g?.line_uuid || (g?._id?.$oid ?? g?._id ?? null),
    participant_uuid: g?.participant_uuid || null,
    participant_display_name: g?.participant_display_name || "",
    line_status: g?.line_status || "SUBMITTED",
  })) : []);

  useEffect(() => {
    if (!orderId) return;

    let cancelled = false;

    const run = async () => {
      try {
        setLoading(true);
        const resp = await OrdersFetchAPI.getTempOrderById(
          orderId,
          localStorage.getItem("x-access-machine-token")
        );
        if (cancelled) return;
        // We expect resp.data.pre_order to contain the order details including items, total, etc.
        const pre = resp?.data?.pre_order;
        setBackendOrder(pre);
        setDraftGroups(normalizeGroupsForEditing(pre?.groups));
      } catch (err) {
        if (!cancelled) console.error(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();

    return () => { cancelled = true; };
  }, [orderId]);

  // This modal used to be a one-time snapshot: it fetched the order once on open and never again,
  // so a waiter watching it while the customer adds items from their phone (ecommerce table
  // session) saw nothing change, and once the account got paid/closed the modal kept showing the
  // stale order until a full page reload. Mirrors the same socket the ecommerce side already uses
  // for this exact order (see smartpay-ecommerce TableSessionContext.jsx and
  // smartpay-dashboard services/tableSessions.js#emitTableSessionEvent /
  // tableSessionOrderItems.js#finalizeMutation, which is what actually broadcasts these).
  useEffect(() => {
    const business = JSON.parse(localStorage.getItem("business") || "null");
    const branchoffice = JSON.parse(localStorage.getItem("branchoffice") || "null");
    if (!business?.code || !branchoffice?.code) return undefined;

    const socket = Socket({ business_code: business.code, branchoffice_code: branchoffice.code });

    const matchesThisOrder = (rawOrder) => {
      const rid = String(rawOrder?._id?.$oid ?? rawOrder?._id ?? rawOrder?.id ?? "");
      return rid !== "" && rid === String(orderId);
    };

    const handleOrderUpdated = (payload = {}) => {
      if (!matchesThisOrder(payload.order)) return;
      setBackendOrder(payload.order);
      setDraftGroups(normalizeGroupsForEditing(payload.order.groups));
    };

    const handleSessionClosed = (payload = {}) => {
      const sessionUuid = payload.session_uuid || payload.session?.session_uuid;
      if (!sessionUuid || sessionUuid !== backendOrder?.table_session_uuid) return;
      AlertSmall("Esta cuenta ya fue pagada/cerrada", "info");
      onClose?.();
    };

    socket.on("tableSessionOrderUpdated", handleOrderUpdated);
    ["tableSessionClosed", "tableSessionExpired", "tableSessionCancelled"].forEach((eventName) => {
      socket.on(eventName, handleSessionClosed);
    });

    return () => {
      socket.off("tableSessionOrderUpdated", handleOrderUpdated);
      ["tableSessionClosed", "tableSessionExpired", "tableSessionCancelled"].forEach((eventName) => {
        socket.off(eventName, handleSessionClosed);
      });
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId, backendOrder?.table_session_uuid]);

  return (
    <>
      <ModalShell
        title={`Detalle de pedido • Mesa ${table.number}`}
        onClose={onClose}
        footer={
          <>
            <div className="ord-footer">

              <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
                Cerrar
              </button>


              <button className="ord-btn ord-btn-secondary" type="button" onClick={onAddMore} disabled={!orderId}>
                <i className="bi bi-plus-lg" /> Agregar productos
              </button>

              {backendOrder?.table_session_uuid && !isPrepayOrder ? (
                <button
                  className="ord-btn ord-btn-secondary"
                  type="button"
                  onClick={authorizeOnlinePayment}
                  disabled={authorizingPayment || paymentAuthorized}
                  title="Habilita el boton Pagar en el celular del cliente"
                >
                  <i className={`bi ${paymentAuthorized ? "bi-check-circle-fill" : "bi-phone"}`} />
                  {" "}
                  {paymentAuthorized ? "Pago habilitado" : "Habilitar pago en linea"}
                </button>
              ) : null}

              {isPrepayOrder ? (
                <button
                  className="ord-btn ord-btn-primary"
                  type="button"
                  onClick={() => setShowPrepayAccountPanel(true)}
                  disabled={!backendOrder?.table_session_uuid}
                >
                  <i className="bi bi-receipt" /> Ver cuenta pre-pago
                </button>
              ) : (
                <button className="ord-btn ord-btn-primary" type="button" onClick={handleSendToPay} disabled={!orderId || sendingToPay}>
                  <i className="bi bi-cash-coin" /> Enviar a pagar
                </button>
              )}

            </div>


          </>
        }
      >
        <div className="ord-scope">
          {!order ? (
            <div style={{ color: "var(--text-secondary)" }}>Pedido no encontrado.</div>
          ) : (
            <>
              <div className="ord-summary">
                <div className="ord-summary-left">
                  <div className="ord-summary-code">
                    <span className="hash">#</span>{formatOrderCode(order)}
                  </div>
                  <div className="ord-summary-status">{order.status || "abierto"}</div>
                  {(() => {
                    // backendOrder is kept live by this modal's own socket listener above (see
                    // handleOrderUpdated); order.client_phone (table.table_orders) only refreshes on
                    // the next full table-list reload, so prefer the live value once it has loaded.
                    const phone = backendOrder ? (backendOrder.client_phone || "") : order.client_phone;
                    return phone && phone !== "0" && phone !== "00" ? (
                      <div className="ord-summary-status ord-donlee-badge">Paisanitos: {phone}</div>
                    ) : null;
                  })()}
                </div>
                <div className="ord-summary-right">
                  <div className="ord-summary-label">Total</div>
                  <div className="ord-summary-total">${order.total.toFixed(2)}</div>
                </div>
              </div>

              <div className="ord-list-head">
                <span className="t">Items</span>
                {/* El backend no borra una linea eliminada (cancelPendingPrepayLines / el cliente la
                    quita): la deja con line_status "CANCELLED". El ecommerce y el panel de cuenta
                    pre-pago ya la ocultan, pero esta lista la seguia mostrando como si existiera. */}
                <span className="c">{draftGroups.filter((g) => g.line_status !== "CANCELLED").length} {draftGroups.filter((g) => g.line_status !== "CANCELLED").length === 1 ? "producto" : "productos"}</span>
              </div>

              <div className="ord-list">
                {draftGroups.filter((g) => g.line_status !== "CANCELLED").length === 0 ? (
                  <div className="ord-empty">Sin items</div>
                ) : (
                  draftGroups.filter((g) => g.line_status !== "CANCELLED").map((it, idx) => {
                    // Etiqueta de negocio, no el enum interno (DRAFT/SUBMITTED/kitchen_action) -
                    // el mesero necesita saber "que puede hacer con esto ya", no el nombre tecnico
                    // del campo. Ver getLineBusinessStatus().
                    const businessStatus = getLineBusinessStatus(it);
                    return (
                      <div key={idx} className={`ord-row ${businessStatus.className}`}>
                        <div className="ord-row-left">
                          <div className="ord-emoji">🍽️</div>
                          <div className="ord-item-main">
                            <div className="ord-name">{it.name}</div>
                            <div className="ord-sub"><span className="ord-qty-chip">x{it.qty || 1}</span></div>

                            <span className={`ord-line-status-badge ${businessStatus.className}`}>
                              {businessStatus.label}
                            </span>

                            {it.participant_display_name ? (
                              <div className="ord-line-participant">
                                <i className="bi bi-person-circle" /> {it.participant_display_name}
                              </div>
                            ) : null}

                            {/* Note (read-only) */}
                            {it.note ? (
                              <div className="ord-note" style={{ color: "var(--text-secondary)" }}>
                                <strong>Nota:</strong> {it.note}
                              </div>
                            ) : null}

                            {/* Elegido por producto al agregarlo (ecommerce) - siempre visible, no
                                escondido en "Detalles", para que el mesero no tenga que adivinar. */}
                            <div className={`ord-delivery-chip${it.delivery_type === "para llevar" ? " ord-delivery-chip-togo" : ""}`}>
                              {it.delivery_type === "para llevar" ? "🥡 Para llevar" : "🍽️ Comer aquí"}
                            </div>

                            {/* Descuento aprobado (ej. Jubilado 15%) - mismo dato que ya se ve en el
                                carrito del ecommerce (BtnShoppingcartFloat.jsx), pero aqui nunca se
                                mostraba: el mesero veia el mismo precio con o sin descuento aplicado. */}
                            {it.discount_request?.status === "APPROVED" && Number(it.discount) > 0 ? (
                              <div className="ord-note" style={{ color: "#0B7A44" }}>
                                Descuento{it.discount_request.discount_name ? ` ${it.discount_request.discount_name}` : ""}
                                {it.discount_request.rate ? ` (${it.discount_request.rate}%)` : ""}
                                : -${Number(it.discount).toFixed(2)}
                              </div>
                            ) : null}

                            {Array.isArray(it.modifiers) && it.modifiers.length > 0 && (
                              <div className="ord-modifiers">
                                {it.modifiers.map((seg) => {
                                  const names = (seg.selections || []).map((s) => s.name).filter(Boolean).join(", ");
                                  if (!names) return null;

                                  return (
                                    <div key={seg.segment_id} style={{ color: "var(--text-secondary)" }}>
                                      <strong>{seg.name}:</strong> {names}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="ord-row-right">
                          <div className="ord-price" style={{ color: "var(--accent-primary)" }}>
                            {/* Mismo calculo que tableSessionOrderSnapshot.js#sanitizeLine usa para
                                line.total en el carrito del ecommerce: (precio*cantidad - descuento) +
                                impuesto. Sin sumar el impuesto, el numero no coincidia con lo que el
                                cliente veia en su telefono para la misma linea. */}
                            ${(
                              Math.max(0, Number(it.price || 0) * Number(it.qty || 1) - Number(it.discount || 0))
                              + getLineTaxTotal(it)
                            ).toFixed(2)}
                          </div>
                          {getLineTaxTotal(it) > 0 ? (
                            <div className="ord-note" style={{ color: "var(--text-secondary)", fontSize: 11, textAlign: "right" }}>
                              Incluye ITBMS ${getLineTaxTotal(it).toFixed(2)}
                            </div>
                          ) : null}

                          {/* Button of send to kitchen. Fase 6: una linea DRAFT todavia pertenece al
                            cliente (puede seguir editandola/borrandola) - el POS no la envia a cocina
                            hasta que el participante la confirme (line_status pasa a SUBMITTED) o el
                            propio POS la reasigne explicitamente. */}
                          {/* Pre-pago: una linea sin pagar no se manda a cocina (el cobro es lo que la
                            libera - ver canSendLineToKitchen). */}
                          <RenderIf isTrue={it.kitchen_action === "hold" && it.line_status !== "DRAFT" && !canSendLineToKitchen(it)}>
                            <div className="ord-note" style={{ color: "var(--text-secondary)", fontSize: 11, textAlign: "right" }}>
                              Se envía a cocina al pagar
                            </div>
                          </RenderIf>
                          <RenderIf isTrue={it.kitchen_action === "hold" && it.line_status !== "DRAFT" && canSendLineToKitchen(it)}>
                            <button
                              type="button"
                              className="ord-btn ord-btn-kitchen ord-btn-sm"
                              disabled={
                                it.kitchen_action !== "hold" ||
                                sendingItemId === String(it?._id?.$oid ?? it?._id) ||
                                loading
                              }
                              onClick={() => sendSingleItemToKitchen(it)}
                            >
                              <i className="bi bi-fire" /> Enviar a cocina
                            </button>
                          </RenderIf>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </>
          )}
        </div>
      </ModalShell>

      {/* Pre-pago (Fase 5): resumen de la cuenta compartida - pagos parciales ya confirmados, saldo
        pendiente, y el cierre del mesero. Con saldo pendiente ya NO se registra solo como efectivo:
        "Cerrar cuenta" abre un picker para eliminar o cobrar de verdad esos productos primero (ver
        showClosePicker abajo); sin ningun pago aun, tambien se puede anular la cuenta completa. */}
      {showPrepayAccountPanel ? (
        <ModalShell
          title={`Cuenta pre-pago • Mesa ${table.number}`}
          onClose={() => { setShowClosePicker(false); setShowPrepayAccountPanel(false); }}
          footer={showClosePicker ? (
            <div className="pap-x-footer">
              <button className="pap-x-btn secondary" type="button" onClick={() => setShowClosePicker(false)} disabled={resolvingPending || voidingAccount}>
                Volver
              </button>
            </div>
          ) : (
            <div className="pap-x-footer ">
              <button className="pap-x-btn secondary" type="button" onClick={() => setShowPrepayAccountPanel(false)}>
                Regresar
              </button>
              <button
                className="pap-x-btn primary"
                type="button"
                onClick={handleCloseAccountClick}
                disabled={forceFinalizing || voidingAccount}
              >
                <i className="bi bi-check2-circle" /> {(forceFinalizing || voidingAccount) ? "Cerrando..." : "Cerrar cuenta"}
              </button>

            </div>
          )}
        >
          {showClosePicker ? (
            <div className="pap-x-scope g-3">
              <div className="pap-x-warn">
                Esta cuenta tiene <strong>${prepayPendingBalance.toFixed(2)}</strong> en productos sin pagar.
                Elige cuáles eliminar (no se cobran) y cuáles cobrar ahora.
              </div>

              <div className="pap-x-list-label mt-3">Productos pendientes</div>
              <div className="pap-x-list">
                {actionablePendingLines.map((line) => (
                  <label
                    key={line.line_uuid}
                    className={`pap-x-pay is-selectable${pendingSelection.has(line.line_uuid) ? " is-selected" : ""}`}
                  >
                    <div className="pap-x-pay-left" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <input
                        type="checkbox"
                        className="pap-x-check"
                        checked={pendingSelection.has(line.line_uuid)}
                        onChange={() => togglePendingSelection(line.line_uuid)}
                        disabled={resolvingPending}
                      />
                      {/* <span className="pap-x-check-box"><i className="bi bi-check-lg" /></span> */}
                      <div className="pap-x-pay-info">
                        <div className="pap-x-pay-name">{line.amount}× {line.name}</div>
                        {line.participant_display_name ? (
                          <div className="pap-x-pay-who">{line.participant_display_name}</div>
                        ) : null}
                        <span className="pap-x-sel-tag"><i className="bi bi-check-circle-fill" /> Seleccionado</span>
                      </div>
                    </div>
                    <strong className="pap-x-pay-amount">${computeLineTotal(line).toFixed(2)}</strong>
                  </label>
                ))}
              </div>

              <div className="pap-x-summary mt-3">
                <div className="pap-x-sumcard is-clear">
                  <span className="k">Total seleccionado</span>
                  <span className="v">${pendingSelectionTotal.toFixed(2)}</span>
                </div>
              </div>

              <div className="pap-x-footer" style={{ padding: 0, marginTop: 8 }}>
                <button
                  className="pap-x-btn secondary"
                  type="button"
                  onClick={handleDeleteSelectedPending}
                  disabled={pendingSelection.size === 0 || resolvingPending}
                >
                  <i className="bi bi-trash" /> Eliminar <br/>  seleccionados
                </button>
                <button
                  className="pap-x-btn primary"
                  type="button"
                  onClick={handlePaySelectedPending}
                  disabled={pendingSelection.size === 0 || resolvingPending}
                >
                  <i className="bi bi-credit-card-2-front" /> Cobrar <br/>
                   seleccionados
                </button>
              </div>

              {prepayPaidTotal === 0 ? (
                <button
                  className="pap-x-btn secondary"
                  type="button"
                  onClick={handleVoidAccount}
                  disabled={resolvingPending || voidingAccount}
                  style={{ width: "100%", marginTop: 10, color: "var(--danger, #E11D2E)" }}
                >
                  <i className="bi bi-x-circle" /> {voidingAccount ? "Anulando..." : "Anular cuenta completa (sin cobrar nada)"}
                </button>
              ) : null}
            </div>
          ) : (
            <div className="pap-x-scope">
              {/* resumen: pagado / saldo */}
              <div className="pap-x-summary">
                <div className="pap-x-sumcard is-clear">
                  <span className="k">Pagado</span>
                  <span className="v">${prepayPaidTotal.toFixed(2)}</span>
                </div>
                <div className={"pap-x-sumcard" + (prepayPendingBalance > 0 ? " is-pending" : " is-clear")}>
                  <span className="k">Saldo pendiente</span>
                  <span className="v" style={{ color: prepayPendingBalance > 0 ? "var(--accent-primary)" : undefined }}>
                    ${prepayPendingBalance.toFixed(2)}
                  </span>
                </div>
              </div>

              {/* pagos registrados */}
              <div className="pap-x-list-label">Pagos registrados</div>
              {prepayPayments.length === 0 ? (
                <div className="pap-x-empty">Sin pagos todavia</div>
              ) : (
                <div className="pap-x-list">
                  {prepayPayments.map((p, idx) => (
                    <div key={p.payment_attempt_id || idx} className="pap-x-pay">
                      <div className="pap-x-pay-left">
                        <div className="pap-x-pay-name">
                          {p.gateway_name || "Pago"}
                          <span className={`pap-x-badge ${p.status === "CONFIRMED" ? "paid" : p.status === "PENDING" ? "charging" : "pending"}`}>
                            {p.status === "CONFIRMED" ? "Confirmado" : p.status === "PENDING" ? "Pendiente" : "Fallido"}
                          </span>
                        </div>
                        {p.participant_display_name ? (
                          <div className="pap-x-pay-who">{p.participant_display_name}</div>
                        ) : null}
                      </div>
                      <strong className="pap-x-pay-amount">${Number(p.amount || 0).toFixed(2)}</strong>
                    </div>
                  ))}
                </div>
              )}

              {/* personalizar factura: a nombre de quien sale la factura final al cerrar la cuenta */}
              <div className="pap-x-inv">
                <div className="pap-x-inv-head">
                  <div className="pap-x-inv-info">
                    <span className="k">Factura</span>
                    {savedInvoice ? (
                      <>
                        <span className="n">{savedInvoice.client_name}</span>
                        {savedInvoice.ruc ? (
                          <span className="s">RUC/Cédula {savedInvoice.ruc}{savedInvoice.dv ? ` DV ${savedInvoice.dv}` : ""}</span>
                        ) : null}
                      </>
                    ) : (
                      <span className="s">Se emitirá a consumidor final</span>
                    )}
                  </div>
                  <button className="pap-x-btn" type="button" onClick={() => setShowInvoiceForm(true)} disabled={forceFinalizing || voidingAccount}>
                    <i className="bi bi-receipt" /> {savedInvoice ? "Editar" : "Personalizar factura"}
                  </button>
                </div>
              </div>

              {/* aviso de saldo pendiente */}
              {prepayPendingBalance > 0 ? (
                <div className="pap-x-warn">
                  Esta cuenta tiene productos pendientes por pagar. Al tocar
                  <strong> “Cerrar cuenta” </strong>
                  podrás elegir eliminarlos o cobrarlos.
                </div>
              ) : prepayPaidTotal === 0 ? (
                <div className="pap-x-warn">
                  Esta cuenta no tiene ningún pago. Al tocar <strong>“Cerrar cuenta”</strong> se anulará por completo.
                </div>
              ) : null}
            </div>
          )}
        </ModalShell>
      ) : null}

      <RfmCustomizeInvoiceModal
        open={showInvoiceForm}
        saved={savedInvoice}
        onClose={() => setShowInvoiceForm(false)}
        onSave={saveInvoiceData}
        onRemove={removeInvoiceData}
      />
    </>
  );
}

